import React, { useState, useCallback, useEffect, Fragment, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from "@material-ui/core/Checkbox";
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import DataTable from "react-data-table-component";
import Button from '@material-ui/core/Button';
import { format } from 'date-fns';
import _ from "lodash";
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal'
import CloseIcon from '@material-ui/icons/Close';
import UtilsService from '../../helpers/utils';
import seqSearchImg from '../../assets/image/seqSearch.png';
import alertImg from '../../assets/image/alert.png';
import searchResultImg from '../../assets/image/searchResult.png';
import notesImg from '../../assets/image/notes.png';
import pencilImg from '../../assets/image/pencil.png';
import TextInput from '../../shared/Fields/TextInput';
import searchResSequence from '../../services/searchResSequence';
import SearchManagementService from '../../services/searchmanagement'
import Constant from '../../helpers/constant';
import { url } from '../../reducers/url';
import SelectBox from '../../shared/Fields/SelectBox';
import RenameContainer from '../../shared/components/RenameContainer'
import SharedWith from '../Sharing/SharedWith.js';
import { containerWidth } from '../../shared/constants';
import ftAccess from '../../services/ftAccess';
import { supportMail } from '../../config';
import LaunchIcon from '@material-ui/icons/Launch';
import { get } from '../../helpers/fetchServicesMethods';
import AccountInfo from '../../services/accountInfo';
import fieldConfig from '../Discover/FieldConfig';
import alertViews from '../../services/alertViews';

const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
        width: '96%',
        margin: '4px auto 28px',
        minHeight: '260px',
        // borderBottom: '1px solid #cec7c7',
        padding: '23px 16px 14px',
        border: '1px solid #cec7c7',
        borderRadius: '3px',
        maxWidth: containerWidth
    },
    headerPipe: {
        margin: '0 10px'
    },
    listStyle: {
        listStyleType: 'none',
        padding: '0 10px'
    },
    failedTextColor: {
        color: '#e17a47 !important'
    },
    content: {
        fontSize: '14px !important',
        lineHeight: '25px',
        color: '#4a5050'
    },
    rowHeight: {
        height: '8%'
    },
    alertSelect: {
        width: '51%'
    },
    // Each label/select pair is floated, so give the row its own block to contain
    // the floats - otherwise a <br> leaves the next label wrapping beside them.
    alertRow: {
        overflow: 'hidden',
        marginBottom: '10px'
    },
    // Fixed width so both dropdowns line up despite the labels differing in length,
    // wide enough for "Frequency of Alerts" to stay on one line.
    alertRowLabel: {
        width: '160px',
        whiteSpace: 'nowrap',
        textAlign: 'left'
    },
    loginSubmitCancel: {
        backgroundColor: '#0182C5',
        borderColor: '#1F4E79',
        border: '1px solid #1F4E79',
        color: 'white',
        margin: '4px',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#0182C5',
            boxShadow: 'none',
        },
    },
    cancelButtonModal: {
        backgroundColor: '#EEEEEE',
        border: '1px solid #CCCCCC',
        float: 'left',
        margin: '4px',
        textTransform: 'none',
        marginTop: '4px',
        color: '#777777',
        boxShadow: 'none'
    },
    modalHeader: {
        borderBottom: 'none !important',
        paddingTop: '14px',
        paddingRight: '1px',
        marginTop: '-7px',
        display: "block !important"
    },
    footerDiv: {
        padding: '0 30px',
        marginTop: '-5px',
        marginRight: '-10px',
    },
    contentPadding: {
        padding: "45px !important"
    },
    modalBoxContent: {
        maxHeight: '675px',
    },
    modalClassContentDSI: {
        // position: 'absolute',
        width: '96%',
        height: '41%',
        // top: '30%',
        // left: '50%',
        right: 'auto',
        bottom: 'auto',
        padding: '20px 10px',
        // transform: 'translate(-50%, -50%)',
    },
    modalClassContentDSIDark: {
        // position: 'absolute',
        width: '96%',
        height: '41%',
        // top: '30%',
        // left: '50%',
        right: 'auto',
        bottom: 'auto',
        padding: '20px 10px',
        // transform: 'translate(-50%, -50%)',
        backgroundColor: '#292929',
    },
    colorContainerDSI: {
        backgroundColor: '#EEEEEE',
        // marginTop: '-26px',
        // marginLeft: 0px;
        paddingTop: '28px',
        // paddingBottom: '75px',
        paddingBottom: '78px',
        // marginLeft: '10px',
        // marginRight: '10px',
        paddingRight: '10px',
        borderRadius: '5px',

    },
    colorContainerDSIDark: {
        backgroundColor: '#56545473',
        // marginTop: '-26px',
        // marginLeft: 0px;
        paddingTop: '28px',
        // paddingBottom: '75px',
        paddingBottom: '78px',
        // marginLeft: '10px',
        // marginRight: '10px',
        paddingRight: '10px',
        borderRadius: '5px',
    },
    modalClassContent: {
        position: 'absolute',
        width: '96%',
        // height: '42%',
        top: '30%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)'
    },
    modalClassContentDark: {
        position: 'absolute',
        width: '96%',
        // height: '42%',
        top: '30%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#292929'
    },
    colorContainer: {
        paddingTop: '28px',
        textAlign: 'left',
        paddingBottom: '53px',
        margin: '20px 10px',
        borderRadius: '5px',
        paddingLeft: '20px'
    },
    colorContainerDark: {
        backgroundColor: '#56545473',
        paddingTop: '28px',
        textAlign: 'left',
        paddingBottom: '53px',
        margin: '20px 10px',
        borderRadius: '5px',
        paddingLeft: '20px'
    },
    buttonStyle: {
        float: 'right',
        textTransform: 'none',
        margin: '4px',
        color: 'white',
        backgroundColor: '##DB862D !important',
        border: '1px solid ##DB862D !important',

    },
    bodyPadding: {
        padding: "15px 10px 0 !important"
    },
    modalHeaderDSI: {
        borderBottom: 'none !important',
        paddingTop: '20px',
        paddingRight: '1px',
        marginTop: '-16px',
        display: "block !important"
    },
    searchTitleText: {
        wordWrap: 'break-word',
        inline_size: '150px',
        overflow: 'hidden',
        cursor: 'pointer'
    },
    highlight: {
        fontWeight: 'bold'
    },
    closeButton: {
        position: 'absolute',
        right: '10px',
        top: '10px'
    },
    mergeGroupTitle: {
        marginLeft: '15px',
        fontSize: '14px !important',
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontWeight: '700'
    },
    checkboxDark: {
        color: 'white',
        borderColor: 'white',
      },
      checkboxLight: {
        color: '#aea9a9',
        borderColor: '#aea9a9',
      }
}));
// Dynamically generate columns based on alertReport existence
const getColumns = (alarmSetting, seqSummary, userInfo, gqUserId, downloadTechLog, isCasNoAccess, hasCasAccess) => {
    const isDocumentSearch = seqSummary && seqSummary.type === "GqWfSearchFT";
    const isSharedOrAdmin = userInfo && userInfo.current_user && (
        (gqUserId && userInfo.current_user.gq_user_id !== gqUserId) ||
        userInfo.current_user.user_class_name === "adminium"
    );
    const isCmBlocked = (row) =>
        (row.type === "GqWfCmSearch" || (row.databases || []).some(db => /^CAS.*_MS$/.test(db))) &&
        userInfo && userInfo.current_user && !userInfo.current_user.cmAccess && !isSharedOrAdmin;

    // Per-row CAS check: uses row.casDatabases if available and non-empty, falls back to workflow-level isCasNoAccess
    const getRowCasFlags = (row) => {
        const casDatabases = row.casDatabases;
        if (casDatabases !== undefined && casDatabases.length > 0 && !hasCasAccess) {
            const casDbsInSearch = (row.databases || []).filter(db => casDatabases.includes(db));
            const rowIsCasNoAccess = casDbsInSearch.length > 0;
            const nonCasDbs = (row.databases || []).filter(db => !casDbsInSearch.includes(db));
            return {
                isCasBlocked: rowIsCasNoAccess,
                isCasOnly: rowIsCasNoAccess && nonCasDbs.length === 0,
                isCasWithOthers: rowIsCasNoAccess && nonCasDbs.length > 0,
            };
        }
        return { isCasBlocked: isCasNoAccess, isCasOnly: false, isCasWithOthers: false };
    };

    const cols = [
        { name: "Date", selector: "date" },
        alarmSetting && alarmSetting.is_created && !isDocumentSearch ? { name: "Alert Report", selector: "alertReport" } : null,
        {
            name: "Results",
            selector: "results",
            cell: row => {
                if (!row.type || row.type === '') return <a href="#" onClick={e => e.preventDefault()}>Empty</a>;
                if (row.type === 'GqWfSeqSearch') return '';
                if (row.type === 'GqFolder') return <a href="#" onClick={e => e.preventDefault()}>Empty</a>;
                if (row.status === 'STILL_RUNNING') return '';
                if (row.status === 'FAILED') return <a href="#" className="failedIconColor" onClick={e => e.preventDefault()}>Search Failed</a>;
                if (row.status === 'ARCHIVED') return <a href="#" className="failedIconColor" onClick={e => e.preventDefault()}>Search Archived</a>;
                if (isCmBlocked(row)) {
                    return row.total_nb_results > 0
                        ? <Tooltip title="Access to these results requires an active subscription to the Chemical Modification Module." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>{row.total_nb_results}</span></Tooltip>
                        : <span style={{color: '#bbb', fontStyle: 'italic'}}>{row.total_nb_results}</span>;
                }
                const { isCasBlocked: rowCasBlocked, isCasOnly, isCasWithOthers } = getRowCasFlags(row);
                if (isCasOnly) {
                    return row.total_nb_results > 0
                        ? <Tooltip title="CAS access required — this search was run against CAS databases only." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>{row.total_nb_results}</span></Tooltip>
                        : <span style={{color: '#bbb', fontStyle: 'italic'}}>{row.total_nb_results}</span>;
                }
                if (isCasWithOthers) {
                    return row.total_nb_results > 0
                        ? <Tooltip title="CAS access required — results from CAS databases are not available." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>{row.total_nb_results}</span></Tooltip>
                        : <span style={{color: '#bbb', fontStyle: 'italic'}}>{row.total_nb_results}</span>;
                }
                if (rowCasBlocked) {
                    return row.total_nb_results > 0
                        ? <Tooltip title="CAS access required to view these results." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>{row.total_nb_results}</span></Tooltip>
                        : <span style={{color: '#bbb', fontStyle: 'italic'}}>{row.total_nb_results}</span>;
                }
                return row.total_nb_results > 0
                    ? <a href={row.typeUrl} target="_blank" rel="noreferrer">{row.total_nb_results}</a>
                    : <span>{row.total_nb_results}</span>;
            }
        },
        {
            name: "Report",
            selector: "report",
            cell: row => {
                if (row.status === 'FAILED' || row.status === 'ARCHIVED') return '';
                if (isCmBlocked(row)) {
                    return <Tooltip title="Access to these results requires an active subscription to the Chemical Modification Module." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>Classic</span></Tooltip>;
                }
                const { isCasBlocked: rowCasBlocked, isCasOnly, isCasWithOthers } = getRowCasFlags(row);
                if (isCasOnly) {
                    return <Tooltip title="CAS access required — this search was run against CAS databases only." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>Classic</span></Tooltip>;
                }
                if (isCasWithOthers) {
                    return <Tooltip title="CAS access required — results from CAS databases are not available." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>Classic</span></Tooltip>;
                }
                if (rowCasBlocked) {
                    return <Tooltip title="CAS access required to view this report." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>Classic</span></Tooltip>;
                }
                if (!row.type || !row.total_nb_results || row.total_nb_results <= 0) return '';
                if (row.type === "GqWfABIpSearch") {
                    return <span><a href={row.reportLink} target="_blank" rel="noreferrer">Report</a><span className="mx-2">|</span><a href={row.classicLink} target="_blank" rel="noreferrer">Classic</a></span>;
                }
                if (row.type !== "GqFolder") {
                    return <a href={row.classicLink} target="_blank" rel="noreferrer">Classic</a>;
                }
                return '';
            }
        },
        {
            name: "SearchId",
            selector: "searchId",
            cell: row => {
                if (isCmBlocked(row)) {
                    return <Tooltip title="Access to these results requires an active subscription to the Chemical Modification Module." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>Search id {row.id}</span></Tooltip>;
                }
                const { isCasBlocked: rowCasBlocked, isCasOnly, isCasWithOthers } = getRowCasFlags(row);
                if (isCasOnly) {
                    return <Tooltip title="CAS access required — this search was run against CAS databases only." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>Search id {row.id}</span></Tooltip>;
                }
                if (isCasWithOthers) {
                    return <Tooltip title="CAS access required — results from CAS databases are not available." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>Search id {row.id}</span></Tooltip>;
                }
                if (rowCasBlocked) {
                    return <Tooltip title="CAS access required." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>Search id {row.id}</span></Tooltip>;
                }
                if (userInfo && userInfo.current_user.user_class_name === "adminium") {
                    return <a href="#" onClick={e => downloadTechLog(e, row.id)}>Search id {row.id}</a>;
                }
                return <span>Search id {row.id}</span>;
            }
        }
    ];
    return cols.filter(Boolean);
};
const searchResultData = [{
    date: "5-Feb-2021",
    result: "1500 Alignments",
    report: "Report",
    id: "Search ID:123"
}, {
    date: "5-Feb-2021",
    result: "1500 Alignments",
    report: "Report",
    id: "Search ID:124"
}, {
    date: "5-Feb-2021",
    result: "1500 Alignments",
    report: "Report",
    id: "Search ID:125"
}]
const customStyles = {
    rows: {
        style: {
            minHeight: '50px', // override the row height
        }
    },
    // subHeader: {
    //     style: {
    //         minHeight: '0 !important'
    //     },
    // },
    // headRow: {
    //     style: {
    //         border: '0 !important',
    //         display: 'none',
    //     }
    // },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            borderLeft: '1px solid #0606061f',
            '&:first-child': {
                borderLeft: '0',
            },
            fontWeight: 'bold',
            color: '#4a5050',
            justifyContent: 'center !important'
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
            borderLeft: '1px solid #0606061f',
            // borderBottom: '1px solid #0606061f',
            '&:first-child': {
                borderLeft: '0',
            },
            display: 'grid',
            justifyContent: 'center !important'
        },

    },
};
const customStylesDark = {
    rows: {
        style: {
            minHeight: '50px', // Override the row height
            backgroundColor: '#292929',
            color: 'white',
        },
    },
    subHeader: {
        style: {
            backgroundColor: '#292929',
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // Override the cell padding for head cells
            paddingRight: '8px',
            borderLeft: '1px solid #ffffff', // Add white border between header cells
            '&:first-child': {
                borderLeft: '0',
            },
            fontWeight: 'bold',
            color: 'white',
            justifyContent: 'center !important',
            backgroundColor: '#292929',
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // Override the cell padding for data cells
            paddingRight: '8px',
            borderLeft: '1px solid #ffffff', // Add white border between data cells
            borderBottom: '1px solid #ffffff !important', // Enforce white border below data rows
            '&:first-child': {
                borderLeft: '0',
            },
            display: 'flex', // Use flex instead of grid for proper alignment
            justifyContent: 'center !important',
            backgroundColor: '#292929',
        },
    },
    noData: {
        style: {
            backgroundColor: '#292929', // Dark mode background for no data message
            color: 'white', // Text color for "No items were found"
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    },
};

const isIndeterminate = indeterminate => indeterminate;
const selectableRowsComponentProps = { indeterminate: isIndeterminate };

function parseRunStats(logText, createTime) {
    if (!logText) return null;

    const extractTimestamp = (label) => {
        const escaped = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp('\\[' + escaped + '\\]\\s*(\\d{4}/\\d{2}/\\d{2}\\s+\\d{2}:\\d{2}:\\d{2})');
        const match = logText.match(regex);
        if (!match) return null;
        const [datePart, timePart] = match[1].split(' ');
        const [year, month, day] = datePart.split('/');
        return new Date(`${year}-${month}-${day}T${timePart}`);
    };

    const formatDuration = (ms) => {
        if (ms < 0) ms = 0;
        const totalSeconds = Math.round(ms / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        return `${String(hours).padStart(2, '0')}hr ${String(minutes).padStart(2, '0')}min ${String(seconds).padStart(2, '0')}sec`;
    };

    const startScriptBody       = extractTimestamp('start SCRIPT BODY');
    const stopScriptBody        = extractTimestamp('stop SCRIPT BODY');
    const startMainComparison   = extractTimestamp('start main comparison');
    const stopMainComparison    = extractTimestamp('stop main comparison');
    const startInitTextIndex    = extractTimestamp('start Initialize TextIndex');
    const stopInitTextIndex     = extractTimestamp('stop Initialize TextIndex');

    const seqCompMs   = (startMainComparison && stopMainComparison) ? (stopMainComparison - startMainComparison) : null;
    const resPrepEnd  = startInitTextIndex || stopScriptBody;
    const resPrepMs   = (stopMainComparison && resPrepEnd) ? (resPrepEnd - stopMainComparison) : null;
    const textIdxMs   = (startInitTextIndex && stopInitTextIndex) ? (stopInitTextIndex - startInitTextIndex) : null;

    const totalMs = (startScriptBody && stopScriptBody) ? (stopScriptBody - startScriptBody) : [seqCompMs, resPrepMs, textIdxMs].reduce((sum, v) => (v != null ? (sum || 0) + v : sum), null);

    return {
        searchStartTime:       startMainComparison
                                   ? format(startMainComparison, 'dd-MMM-yyyy HH:mm:ss')
                                   : null,
        searchRunningTime:     seqCompMs != null ? formatDuration(seqCompMs) : null,
        resultPreparationTime: resPrepMs != null ? formatDuration(resPrepMs) : null,
        textIndexingTime:      textIdxMs != null ? formatDuration(textIdxMs) : null,
        totalRuntime:          totalMs != null ? formatDuration(totalMs) : null,
    };
}

function SearchResultSequence(props) {
    const { t, i18n } = useTranslation('common');
    const classes = useStyles();
    const history = useHistory();
    const [selectData, setSelectData] = useState();
    const [disableDelete, setDisableDelete] = useState(true);
    const [seqSummary, setSeqSummary] = useState();
    const [mergeSummary, setMergeSummary] = useState();
    const [ftQuery, setFtQuery] = useState();
    const [cmQuery, setCmQuery] = useState();
    const [cmQueryPatterns, setCmQueryPatterns] = useState();
    const [cmNoSeq, setCmNoSeq] = useState(false);
    const [seqShare, setSeqShare] = useState();
    const [alarmSetting, setAlarmSetting] = useState({});
    const [alertData, setAlertData] = useState([]);
    const [alertRedoData, setAlertRedoData] = useState([]);
    const [redoData, setRedoData] = useState([]);
    const [removeData, setRemoveData] = useState([]);
    const [techincalData, setTechincalData] = useState();
    const { workflowId } = useParams();
    const [notes, setNotes] = useState();
    const [searchHistoryData, setSearchHistoryData] = useState([]);
    const [querySeqData, setQuerySeqData] = useState(null);
    const [runStatsData, setRunStatsData] = useState(null);
    const [copiedToClipboard, setCopiedToClipboard] = useState(false);
    const updateState = useCallback(state => setSelectData(state));
    //using state
    const userInfo = useSelector(state => state.setUserInfo);

    // Table Data Delete Variable
    const [confirmContent, setConfirmContent] = useState(true);
    const [delLoaderContent, setDelLoaderContent] = useState(false);
    const [errorContent, setErrorContent] = useState(false);
    const [modalShow, setModalShow] = React.useState(false);
    const [modalResultRemoveShow, setModalResultRemoveShow] = React.useState(false);
    const [termsDisable, setTermsDisable] = React.useState(false);
    const [deleteType, setDeleteType] = React.useState('single');

    // Alert Setting Modal
    const [alertSettingModal, setAlertSettingModal] = useState(false);
    const [alertSettingData, setAlertSettingData] = useState([]);
    const [alertSettingValue, setAlertSettingValue] = useState();

    // The saved view an alert reports its new results with. Loaded when the dialog
    // opens rather than on page load: it costs two requests and only this dialog
    // needs it.
    const [alertViewData, setAlertViewData] = useState([]);
    // Kept in step with alertViewValue below.
    const [alertViewValue, setAlertViewValue] = useState('default');
    // Guards the load of the view list; a ref so the check is synchronous.
    const alertViewLoading = useRef(false);
    // Mirrors alertViewValue so the loader can read the latest without a stale closure
    // and without putting logic inside a state updater.
    const alertViewValueRef = useRef('default');

    // Result Sharing
    const [readShareId, setReadShareId] = useState();
    const [writeShareId, setWriteShareId] = useState();
    const [gqUserId, setGqUserId] = useState();

    // Get User List
    const [userList, setUserList] = useState();

    const [modalResultShow, setModalResultShow] = React.useState(false);

    // To Update Title
    const [updateTitle, setUpdateTitle] = useState(false);
    const titleNameRef = useRef('');
    const [titleNameErr, setTitleNameErr] = useState(false);

    // To disable shared user ids in add share popup
    const [sharedIds, setSharedIds] = useState([]);
    const [resultWritable, setResultWritable] = useState(true);

    // To detect outside click
    const wrapperRef = useRef(null);

    //To display archive message
    const [archiveMsg, setArchiveMsg] = useState(false);
    const [hasCasAccess, setHasCasAccess] = useState(false);
    const toggle = useSelector(state => state.setToggle.toggle);
    
    // Alert Report Modal
    const [alertReportModal, setAlertReportModal] = useState(false);
    const [alertReportData, setAlertReportData] = useState(null);

    // Execute scripts after HTML is injected into modal
    useEffect(() => {
        if (alertReportModal && alertReportData) {
            // Define scrollToTable function in window scope
            window.scrollToTable = function(tableId) {
                const element = document.getElementById(tableId);
                if (!element) return;

                // Find the modal body (scrollable container)
                const modalBody = document.querySelector('.modal-body');
                if (modalBody) {
                    // Calculate position relative to modal body
                    const elementTop = element.offsetTop;
                    modalBody.scrollTop = elementTop - 20;
                } else {
                    // Fallback to normal scroll
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            };

            // Cleanup function to remove the global function
            return () => {
                delete window.scrollToTable;
            };
        }
    }, [alertReportModal, alertReportData]);

    const sharedWithMe = useRef('none');
    const getSharedWith = async (id) => {
        const results = await ftAccess.sharedWith(id);
        if (results && results.response_status === 0) {
            if (results.response_content && results.response_content !== 'none') {
                sharedWithMe.current = results.response_content;
                const sharedToNames = Object.keys(results.response_content).map((item) => {
                    return results.response_content[item].full_name
                })
                let sharedToNamesString = '';
                if (Array.isArray(sharedToNames) && (sharedToNames.length > 3)) {
                    sharedToNamesString = <span><b>{sharedToNames[0]}</b> et al.</span>
                } else {
                    for (let i = 0; i < sharedToNames.length; i++) {
                        if (i === 0) {
                            sharedToNamesString = <>{sharedToNamesString} <b>{sharedToNames[i]}</b></>
                        } else if (i !== (sharedToNames.length - 1)) {
                            sharedToNamesString = <>{sharedToNamesString}, <b>{sharedToNames[i]}</b></>
                        } else {
                            sharedToNamesString = <>{sharedToNamesString} <span>and</span> <b>{sharedToNames[i]}</b> </>
                        }
                    }
                    sharedToNamesString = <span>{sharedToNamesString}</span>
                }
                setSeqShare({ 'sharedNames': sharedToNamesString })
            } else {
                sharedWithMe.current = 'none';
                setSeqShare({ 'sharedNames': '' })
            }
        }
    }

    // reset login status
    useEffect(async () => {
        getSummaryResp();
        getSharedWith(workflowId);

        getAlertResp();
        getAlertRedoResp();
        loadQuerySeqData(); // Load query sequences data on page load

        document.addEventListener("keydown", escFunction, false);
        document.title = 'GenomeQuest - Search Result Report- Sequence';
        let tempAlertArr = [];

        _.each(Constant['alertOptions'], (value, key) => {
            if (key !== 'null') {
                let tempObj = { value: key, label: value };
                alertSettingData.push(tempObj)
            }

        });
        setAlertSettingData([...alertSettingData])
        // setAlertSettingValue(7);
        // document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", escFunction, false);
        };
        // return () => {
        //     document.removeEventListener("keydown", escFunction, false);
        // };
    }, []);

    const escFunction = useCallback((event) => {
        if (updateTitle && event.keyCode === 27) {
            //Do whatever when esc is pressed
            setUpdateTitle(false);
        }
    }, []);
    // const handleClickOutside = event => {
    //     if (event.target.type !== "text") {
    //         disableTitleText();
    //     }
    // };
    // const disableTitleText = async () => {
    //     setUpdateTitle(false);
    // };

    const getSummaryResp = async () => {
       
        const getSummaryResponse = await searchResSequence.getSequenceSummary(workflowId);
        //let getSummaryResponse = await testseq.seqTest //testBed

        if (getSummaryResponse && getSummaryResponse.response_status === 0) {
            let diskUsage = getSummaryResponse.response_content.disk_usage;
            let usedSpace = 0;
            if (diskUsage) {
                usedSpace = (diskUsage / (1024 * 1024));
                usedSpace = usedSpace.toFixed(2);
            }
            titleNameRef.current = getSummaryResponse.response_content.text_label;
            setGqUserId(getSummaryResponse.response_content.gq_user_id);
            setResultWritable(getSummaryResponse.response_content._is_writable)
            // setSharedIds(getSummaryResponse.response_content.gq_user_id);
            getSummaryResponse.response_content['usedSpace'] = usedSpace;
            if (getSummaryResponse.response_content.description) {
                setNotes(getSummaryResponse.response_content.description);
            }
            if(getSummaryResponse.response_content.status === "ARCHIVED"){
                setArchiveMsg(true);
            }
            setSeqSummary(getSummaryResponse.response_content);

            const accountData = await AccountInfo.getAccountInfo(history);
            if (accountData && accountData.response_content) {
                setHasCasAccess(Boolean(accountData.response_content.casAccess));
            }

            // Fetch run statistics from technical log
            const runStatsResponse = await searchResSequence.getSeqTechnical(workflowId, null, false);
            if (runStatsResponse) {
                setRunStatsData(parseRunStats(runStatsResponse, getSummaryResponse.response_content.create_time));
            }
        }
        if (getSummaryResponse && getSummaryResponse.response_status === 0 && getSummaryResponse.response_content.type === "GqWfSearchFT") {
            const getFtQueryResponse = await searchResSequence.getFulltextQuery(workflowId);
            if(getFtQueryResponse && getFtQueryResponse.response_status === 0 && getFtQueryResponse.response_content){
                setFtQuery(getFtQueryResponse.response_content.displayString);
            }
        }
        if (getSummaryResponse && getSummaryResponse.response_status === 0 && getSummaryResponse.response_content.type === "GqWfCmSearch") {
            const response = await searchResSequence.getCmQuery(workflowId);
            if (response && response.response_status === 0 && response.response_content) {
                setCmQuery(response.response_content.displayString);
                setCmQueryPatterns(response.response_content.qpDisplayString);
            }            
            const qdbSeqEmpty = getSummaryResponse.response_content.params?.qdb_seq_empty;        
            const hasNoQuery = qdbSeqEmpty === "1";
            setCmNoSeq(hasNoQuery);
        }
        if (getSummaryResponse && getSummaryResponse.response_status === 0 && getSummaryResponse.response_content.type === "GqWfMerge") {
            const getMergeStrategyResponse = await searchResSequence.getMergeStrategy(workflowId);
            if(getMergeStrategyResponse && getMergeStrategyResponse.response_status === 0){
                const mergeresponse = JSON.parse(getMergeStrategyResponse.response_content);
            
                if(mergeresponse.mergeType === "COMPLETE"){
                    mergeresponse.mergeType = "Complete merge, of every document listed in Group A and Group B";
                }
                else if(mergeresponse.mergeType === "OVERLAP"){
                    mergeresponse.mergeType = "Overlap merge of documents common to both Group A and Group B";
                }
                else if(mergeresponse.mergeType === "ONLY_A_B"){
                    mergeresponse.mergeType = "Non-overlap merge of only documents unique to Group A or Group B";
                }
                else if(mergeresponse.mergeType === "ONLY_A"){
                    mergeresponse.mergeType = "Non-overlap merge of only documents unique to Group A";
                }
                else if(mergeresponse.mergeType === "ONLY_B"){
                    mergeresponse.mergeType = "Non-overlap merge of only documents unique to Group B";
                }
                for (let d in mergeresponse.groupA) {
                    let mergelistClick = await searchResSequence.getSequenceSummary(mergeresponse.groupA[d].workflowId);
                    if (mergelistClick && mergelistClick.response_status === 0 && mergelistClick.response_content) {
                        mergeresponse.groupA[d].click = "Clickable";
                        mergeresponse.groupA[d].memberType = mergelistClick.response_content.type;
                        if (mergelistClick.response_content.type === "GqWfCmSearch" &&
                            mergelistClick.response_content.params?.qdb_seq_empty === "1") {
                            mergeresponse.groupA[d].isCmNoSeq = true;
                        }
                    }
                    else{
                        mergeresponse.groupA[d].click = "NotClickable";
                    }

                  }
                  for (let d in mergeresponse.groupB) {
                    let mergelistClick = await searchResSequence.getSequenceSummary(mergeresponse.groupB[d].workflowId);
                    if (mergelistClick && mergelistClick.response_status === 0 && mergelistClick.response_content) {
                        mergeresponse.groupB[d].click = "Clickable";
                        mergeresponse.groupB[d].memberType = mergelistClick.response_content.type;
                        if (mergelistClick.response_content.type === "GqWfCmSearch" &&
                            mergelistClick.response_content.params?.qdb_seq_empty === "1") {
                            mergeresponse.groupB[d].isCmNoSeq = true;
                        }
                    }
                    else{
                        mergeresponse.groupB[d].click = "NotClickable";
                    }

                  }
                console.log(mergeresponse,"mergeresponse");
                  setMergeSummary(mergeresponse);
            }
            
            
        }


    }
    const getAlertResp = async () => {
        const getAlertResponse = await searchResSequence.getSeqAlert(workflowId);
        if (getAlertResponse && getAlertResponse.response_status === 0) {
            if (getAlertResponse.response_content.relaunch_interval === "" || getAlertResponse.response_content.relaunch_interval === null) {
                getAlertResponse.response_content.relaunch_interval = 0;
            }
            setAlertSettingValue(getAlertResponse.response_content.relaunch_interval);
            // Stored view for this alert. Null when the owner has never picked one, in
            // which case the alert reports with Default View, so show that rather than
            // an empty box - see DEFAULT_ALERT_VIEW in FulltextUtils.
            const storedAlertView = getAlertResponse.response_content.alert_view_name || 'default';
            alertViewValueRef.current = storedAlertView;
            setAlertViewValue(storedAlertView);
            setAlarmSetting(getAlertResponse.response_content);
        }
    }

    const getAlertRedoResp = async () => {
        const getAlertRedoResponse = await searchResSequence.getAlertRedo(workflowId);
        if (getAlertRedoResponse && getAlertRedoResponse.response_status === 0 && getAlertRedoResponse.response_content.relatives.length > 0) {
            setAlertRedoData(getAlertRedoResponse.response_content.relatives);
            let searchHistoryArr = [];
            getAlertRedoResponse.response_content.relatives.map(function (values, key) {
                let tempObj = {};
                tempObj['date'] = values.create_time ? format(new Date(values.create_time), 'dd-MMM-yyyy') : null;

                // Raw fields — CM-access logic handled at render time in getColumns cell renders
                tempObj['type'] = values.type;
                tempObj['databases'] = values.databases || [];
                tempObj['casDatabases'] = values.casDatabases || [];
                tempObj['status'] = values.status;
                tempObj['total_nb_results'] = values.total_nb_results;

                // Compute URLs here since url constants are not available at render time
                let mostRecentTypeUrl = url.mostRecentTypeUrl.replace('**', values.id);
                tempObj['typeUrl'] = process.env.REACT_APP_BASE_URL + mostRecentTypeUrl;

                let classicLink = process.env.REACT_APP_API_URL + url.mostRecentClassicUrl.replace('**', values.id);
                if (values.type === 'GqWfSeqSearch') {
                    classicLink = process.env.REACT_APP_API_URL + url.mostRecentClassicBlastUrl.replace('**', values.id);
                }
                tempObj['classicLink'] = classicLink;

                if (values.type === "GqWfABIpSearch") {
                    tempObj['reportLink'] = process.env.REACT_APP_BASE_URL + url.mostRecentReportUrl.replace('**', values.id);
                }

                // alertReport: pre-built here as it references HandleAlertReport (component-scoped)
                if (values.status === 'STILL_RUNNING' || values.status === 'FAILED' || values.status === 'ARCHIVED') {
                    tempObj['alertReport'] = '';
                } else {
                    tempObj['alertReport'] = HandleAlertReport(values.id, values.parent_workflow_id);
                }

                tempObj["id"] = values.id;
                searchHistoryArr.push(tempObj);
                // if (values.credit_code === "redo" || values.credit_code === null) {
                //     redoArr.push(tempObj);
                // } else {
                //     alertArr.push(tempObj);
                // }
            });
            setSearchHistoryData(searchHistoryArr);
            // setRedoData(redoArr);
            // setAlertData(alertArr);
        } else {
            if (getAlertRedoResponse && getAlertRedoResponse.response_content.type === "GQDISPATCHERPRIMARYOBJECTNOTFOUNDEXCEPTION") {
                history.push('/searchResult');
            }
        }
    }
    const downloadAlertHtml = async (e, targetWorkflowId) => {
        e.preventDefault();
        try {
            // Call backend to get the alert HTML using the get() helper
            const apiUrl = `do=gqworkflow.get_alert_html&workflow=id:${targetWorkflowId}`;
            const response = await get(apiUrl, history);

            // Check for errors in response
            if (!response) {
                toast.error('Failed to generate alert report - no response from server');
                return;
            }

            // If response is HTML string, display it in modal
            if (typeof response === 'string') {
                const htmlContent = response;

                // Check if the response indicates no alert was created
                if (htmlContent.includes('Alert email not found') || htmlContent.includes('not found')) {
                    toast.warning('Alert has not been created for this search');
                    return;
                }

                // Display HTML in modal
                setAlertReportData(htmlContent);
                setAlertReportModal(true);
            } else if (response.response_status === 0) {
                // Error response
                const errorMsg = response.response_content?.message || 'Failed to generate alert report';
                console.error('Alert API Error:', response);
                toast.error(errorMsg);
            } else {
                console.error('Unexpected response format:', response);
                toast.error('Unexpected response format from server');
            }

        } catch (error) {
            console.error('Error downloading alert HTML:', error);
            const errorMsg = error?.response_content?.message || error?.message || 'Error generating alert report';
            toast.error(errorMsg);
        }
    };

    function HandleAlertReport(targetWorkflowId = workflowId, parentWorkflowId = null) {
        if (!targetWorkflowId ) {
            return null;
        }

        // For the original search (no parent_workflow_id), display dash
        // Original searches don't have a parent, so parent_workflow_id will be null/undefined
        if (!parentWorkflowId) {
            return '-';
        }

        return (
            <Fragment>
                <Link
                    to={`/alert-report/${targetWorkflowId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="appLink"
                    title="View Alert Report"
                    style={{ display: 'inline-flex', alignItems: 'center' }}
                >
                    <LaunchIcon fontSize="small" style={{ marginRight: 4 }} />
                    Alert Report
                </Link>
            </Fragment>
        );
    }
    function updateVal(state) {
        if (state.selectedCount > 0) {
            setDisableDelete(false);
        } else {
            setDisableDelete(true);
        }
        setSelectData(state)
    }
    const handleScroll = (e, id) => {
        document.getElementById(id).scrollIntoView();
        // const item = ReactDOM.findDOMNode(id);
        // var element = document.querySelector("#"+id);
        // element.scrollIntoView();
        // element.scrollIntoView({ behavior: 'smooth', block: 'start'});
        e.preventDefault();
        // window.scrollTo(myElement);
    }
    
    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(querySeqData);
            setCopiedToClipboard(true);
            setTimeout(() => setCopiedToClipboard(false), 2000);
        } catch (err) {
            toast.error('Failed to copy to clipboard');
        }
    }
    const closeModal = () => {
        setModalShow(false);
        setTermsDisable(false);
        setConfirmContent(true);
        setErrorContent(false);
    }
    const deleteSearch = async (type) => {
        setDeleteType(type)
        if (type === "single") {
            if (selectData && selectData.selectedCount > 0) {
                setModalShow(true);
                setConfirmContent(true);
            }
        } else {
            setModalShow(true);
            setConfirmContent(true);
        }

    }
    const deleteConfirm = async () => {
        setModalShow(false);
        setConfirmContent(false);
        var getIds = '';
        if (deleteType === "single") {
            getIds = selectData.selectedRows.map(function (a) { return a.id; }).join(',');
        } else {
            getIds = alertRedoData.map(function (a) { return a.id; }).join(',');
        }
        const deleteResp = await SearchManagementService.deleteSearchResult(getIds, history);
        // setModalShow(true);
        setDelLoaderContent(true);
        if (deleteResp && deleteResp.response_content && deleteResp.response_content.success.length > 0) {
            toast.success('Deleted Successfully');
            // getAlertRedoResp();
            if (deleteType === "single") {
                getAlertRedoResp();
            } else {
                history.push('/searchResult');
            }

        } else {
            toast.error('Unable to Delete');
            setModalShow(true);
            setDelLoaderContent(false);
            setErrorContent(true);
        }
    }

    const loadQuerySeqData = async () => {
        const data = await searchResSequence.downloadQuerySeq(workflowId, history, false);
        if (data !== undefined) {
            setQuerySeqData(data);
        }
    }

    const downloadQuerySeq = async (e) => {
        e.preventDefault()
        await searchResSequence.downloadQuerySeq(workflowId, history);
    }
    const downloadTechLog = async (e, workflowId) => {
        e.preventDefault()
        await searchResSequence.getSeqTechnical(workflowId, history);
    }
    const downloadQueryNoHits = async (e, workflowId) => {
        e.preventDefault()
       let  fil = await searchResSequence.getQueryNoHits(workflowId, history);
    }
    const showAlertModal = async (e) => {
        e.preventDefault();
        setAlertSettingModal(!alertSettingModal)
        loadAlertViews();
    }

    /**
     * Fill the view dropdown with the user's own saved views plus the ones shared
     * with them, under the same names Saved Views shows. Loaded once per page.
     */
    const loadAlertViews = async () => {
        // A ref, not state: state updates are asynchronous, so two quick opens would
        // both see the old value and fetch twice. Released again on failure so a later
        // open can retry instead of the dialog being stuck with whatever it has.
        if (alertViewLoading.current) {
            return;
        }
        alertViewLoading.current = true;
        try {
            // Same CM test the page uses elsewhere, so the CM default is offered on
            // exactly the results whose Saved Views sidebar shows it.
            const cmSeqDbs = [...(seqSummary?.params?.nucdbs || []), ...(seqSummary?.params?.protdbs || [])];
            const isCmResult = Boolean(seqSummary && (
                seqSummary.type === "GqWfCmSearch" ||
                seqSummary.parent_type === "GqWfCmSearch" ||
                cmSeqDbs.some(db => /^CAS.*_MS$/.test(db)) ||
                (seqSummary.databases || []).some(db => /^CAS.*_MS$/.test(db))
            ));
            const listing = await alertViews.listAlertViews(isCmResult);
            const items = listing.items;
            // Decided here rather than inside the setAlertViewValue updater: an updater
            // must be free of side effects, or StrictMode's double invocation shows the
            // warning twice.
            const stored = alertViewValueRef.current;
            const match = stored ? alertViews.findAlertViewItem(items, stored) : undefined;

            if (!stored) {
                alertViewValueRef.current = 'default';
                setAlertViewValue('default');
            } else if (match) {
                // Normally the stored value itself. A shared view saved as a bare name
                // comes back under the value that records its owner, so the next save
                // stores that; one that cannot be pinned down comes back as is, to list.
                if (!items.includes(match)) {
                    items.push(match);
                }
                if (match.value !== stored) {
                    alertViewValueRef.current = match.value;
                    setAlertViewValue(match.value);
                }
            } else if (listing.ownViewsLoaded && listing.sharedViewsLoaded) {
                // The view really is gone - deleted in Discover, or no longer shared
                // with them. Fall back to Default View, which is what the alert itself
                // falls back to, rather than leaving a value with no matching option,
                // which renders as an empty box. Say so: the owner chose that view, and
                // saving from here would quietly replace their choice.
                alertViewValueRef.current = 'default';
                setAlertViewValue('default');
                toast.warning('The view "' + alertViews.alertViewLabel(stored) + '" this alert used is no longer'
                    + ' available. It will report with Default View unless you choose another.');
            } else {
                // Some saved views could not be read, so the list is incomplete and says
                // nothing about whether this view still exists. Keep it selected and
                // listed so the alert's setting is visible and survives a save.
                items.push({ value: stored, label: alertViews.alertViewLabel(stored), builtIn: false });
                toast.warning('Some saved views could not be loaded, so the list may be'
                    + ' incomplete. This alert still uses "' + alertViews.alertViewLabel(stored) + '".');
            }

            setAlertViewData(items);
        } catch (error) {
            console.log('could not load the alert view list', error);
            toast.error('Could not load the list of export templates. Please reopen Alert Setting.');
        } finally {
            alertViewLoading.current = false;
        }
    }
    const updateAlertSettings = async () => {
        setAlertSettingModal(!alertSettingModal)
        let alertVal = alertSettingValue;
        if (alertVal === 0) {
            alertVal = '';
        }
        // Only send the view when the list it came from actually loaded and still holds
        // it. If the load failed we have no idea what exists, and sending a name from a
        // stale dropdown would overwrite the owner's choice with something deleted -
        // omitting the parameter leaves the stored view untouched.
        let alertViewToSave = alertViewValue;
        if (!alertViewData.length || !alertViewData.some((item) => item.value === alertViewValue)) {
            alertViewToSave = undefined;
            toast.warning('The alert frequency was saved. The Export Template was left'
                + ' unchanged because the list of templates could not be confirmed.');
        }
        const getSettingResponse = await searchResSequence.updateAlertSettings(workflowId, alertVal, alertViewToSave);
        if (getSettingResponse && getSettingResponse.response_status === 0) {
            getAlertResp();
        } else {
            toast.error('Update in Error.');
        }
    }
    const removeAlert = async (e) => {
        e.preventDefault();
        const getremoveResponse = await searchResSequence.removeAlertSettings(workflowId);
        if (getremoveResponse && getremoveResponse.response_status === 0) {
            getAlertResp();
        } else {
            toast.error('Removing in Error.');
        }
    }

    function cancelForm() {
        setModalResultRemoveShow(false);
    }

    const updateNewTitle = async (name) => {
        // if (e.keyCode === 13) {
        if (titleNameErr) {
            return;
        }
        let updateParam = '&text_label=' + name;
        titleNameRef.current = name;
        updateSeqData(workflowId, updateParam);
        // }
    }
    const toastId = useRef(null)
    const updateNotes = async () => {
        if (notes) {
            let updateParam = '&description=' + encodeURIComponent(notes);
            updateSeqData(workflowId, updateParam);
        } else {
            if (!toast.isActive(toastId.current)) {
                toastId.current = toast.error('Please Enter Notes to Save Changes.')
            }
        }
    }
    const updateSeqData = async (workflowId, updateParam) => {
        const getnotesResponse = await searchResSequence.updateSeqNotes(workflowId, updateParam);
        if (getnotesResponse && getnotesResponse.response_status === 0) {
            getSummaryResp();
            toast.success('Updated Successfully');

        } else {
            toast.error('Update in Error.');
        }
        setUpdateTitle(false);
    }
    const showUpdateTitleText = (e) => {
        e.preventDefault();
        titleNameRef.current = seqSummary.text_label;
        setUpdateTitle(true);
    }
    const updateTitleName = async (e) => {
        titleNameRef.current = e.target.value;
        if (e.target.value.length > 188) {
            setTitleNameErr(true);
        } else {
            setTitleNameErr(false);
        }
    }
    function searchResult() {
        history.push('/searchResult')
    }
    function mergeLink(wid) {
     
       
    }

    const [selectAll, setSelectAll] = useState(false)
    // const buttonLabels = ['Select All Results', 'Deselect All Results'];
    // const [buttonIndex, setButtonIndex] = useState(0);
    const rowSelectionCriteria = row => row.date !== null;

    const defaultRowSelectionCriteria = row => {};

    const [toggleCleared, setToggleCleared] = React.useState(false);
    const ToggleAllRowsSelected = () => {
        setToggleCleared(!toggleCleared);
        /*const nextSelectionState = !selectAll;
        const newSelectedRows = searchHistoryData.map(row =>
            rowSelectionCriteria(row) ? nextSelectionState : false
        );
        const selectableRowsComponent = 'true'*/
        setSelectAll(!selectAll);
        setSearchHistoryData([...searchHistoryData]);
        //console.log("new follow up data:",nextSelectionState);
        //setselectAll(selectAll)
        //setselectAll(selectAll)
    }

    const selectableRowsComponentProps = {
        type: 'checkbox',
        className: toggle ? 'checkbox-light-mode' : 'checkbox-dark-mode',
        style: {
          color: toggle ? 'grey' : 'rgb(174, 169, 169)',
        },
    };

    // has_cas_db / has_non_cas_db are computed by the backend in gqworkflow.get_info_ft
    const isCasNoAccess = !hasCasAccess && seqSummary?.has_cas_db;
    const isCasOnly = isCasNoAccess && !seqSummary?.has_non_cas_db;
    const isCasWithOthers = isCasNoAccess && seqSummary?.has_non_cas_db;
    const seqDbs = [...(seqSummary?.params?.nucdbs || []), ...(seqSummary?.params?.protdbs || [])];
    const isCmNoAccess = seqSummary && (
        seqSummary.type === "GqWfCmSearch" ||
        seqSummary.parent_type === "GqWfCmSearch" ||
        seqDbs.some(db => /^CAS.*_MS$/.test(db)) ||
        (seqSummary.databases || []).some(db => /^CAS.*_MS$/.test(db))
    ) && userInfo && userInfo.current_user && !userInfo.current_user.cmAccess;

    /*console.log('[CAS Access Debug]', {
        hasCasAccess,
        has_cas_db: seqSummary?.has_cas_db,
        has_non_cas_db: seqSummary?.has_non_cas_db,
        isCasNoAccess,
        isCasOnly,
        isCasWithOthers,
        isCmNoAccess,
        cmAccess: userInfo?.current_user?.cmAccess,
        seqType: seqSummary?.type,
        seqStatus: seqSummary?.status,
    });*/
    const isRunning = seqSummary?.status === 'STILL_RUNNING';
    const isCancelled = seqSummary?.status === 'CANCELLED';
    const isFailed = seqSummary?.status === 'FAILED';

    return (
        <div className={classes.grow}>
            <Row className="p-3">
                <Col lg="12" md="12" sm="12" className="mb-5">
                    <Typography className={classes.root + " float-right"}>
                        <span className={classes.pTagMargin}><a onClick={searchResult}>{t('allSearchResults')}</a></span>
                        { seqSummary && seqSummary.status === "FINISHED" && seqSummary.type === "GqWfIpSearch" &&
                            <span>
                                <span className={classes.headerPipe + " appTextColor"}>|</span>
                                {isCasOnly
                                    ? <Tooltip title="CAS access required to redo this search" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('redoSearch')}</span></Tooltip>
                                    : <Link to={"/ipseqsearch/" + encodeURIComponent(seqSummary.workflow_id)} title={t('redoSearch')} className={"appLink appLink"}>{t('redoSearch')}</Link>
                                }
                            </span>
                        }
                        { seqSummary && seqSummary.status === "FINISHED" && seqSummary.type === "GqWfIpSearchVM" &&
                            <span>
                                <span className={classes.headerPipe + " appTextColor"}>|</span>
                                {isCasOnly
                                    ? <Tooltip title="CAS access required to redo this search" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('redoSearch')}</span></Tooltip>
                                    : <Link to={"/ipseqvariation/" + encodeURIComponent(seqSummary.workflow_id)} title={t('redoSearch')} className={"appLink appLink"}>{t('redoSearch')}</Link>
                                }
                            </span>
                        }
                        { seqSummary && seqSummary.status === "FINISHED" && seqSummary.type === "GqWfABIpSearch" &&
                            <span>
                                <span className={classes.headerPipe + " appTextColor"}>|</span>
                                {isCasOnly
                                    ? <Tooltip title="CAS access required to redo this search" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('redoSearch')}</span></Tooltip>
                                    : <Link to={"/searchresantibody/" + encodeURIComponent(seqSummary.workflow_id)} title={t('redoSearch')} className={"appLink appLink"}>{t('redoSearch')}</Link>
                                }
                            </span>
                        }
                        { seqSummary && seqSummary.status === "FINISHED" && seqSummary.type === "GqWfSearchFT" &&
                            <span>
                                <span className={classes.headerPipe + " appTextColor"}>|</span>
                                {isCasOnly
                                    ? <Tooltip title="CAS access required to redo this search" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('redoSearch')}</span></Tooltip>
                                    : <Link to={"/fulltextsearch/" + encodeURIComponent(seqSummary.workflow_id)} title={t('redoSearch')} className={"appLink appLink"}>{t('redoSearch')}</Link>
                                }
                            </span>
                        }
                        { seqSummary && seqSummary.status === "FINISHED" && seqSummary.type === "GqWfCmSearch" && userInfo && userInfo.current_user && userInfo.current_user.cmAccess &&
                            <span>
                                <span className={classes.headerPipe + " appTextColor"}>|</span>
                                {isCasOnly
                                    ? <Tooltip title="CAS access required to redo this search" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('redoSearch')}</span></Tooltip>
                                    : <Link to={"/cmsearch/" + encodeURIComponent(seqSummary.workflow_id)} title={t('redoSearch')} className={"appLink appLink"}>{t('redoSearch')}</Link>
                                }
                            </span>
                        }
                        { seqSummary && seqSummary.status === "FINISHED" && seqSummary.type === "GqWfCmSearch" && userInfo && userInfo.current_user && !userInfo.current_user.cmAccess &&
                            <span>
                                <span className={classes.headerPipe + " appTextColor"}>|</span>
                                <Tooltip title="CM access required to redo this search" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('redoSearch')}</span></Tooltip>
                            </span>
                        }
                        <span className={classes.headerPipe + " appTextColor"}>|</span>
                        <span className={"appTextColor appLink"} title={t('auditTrial')}>
                            {t('auditTrial')}
                        </span>
                        <span className={classes.headerPipe + " appTextColor"}>|</span>
                        {isCmNoAccess
                            ? <Tooltip title="CM access required" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('resSharing')}</span></Tooltip>
                            : isCasNoAccess
                            ? <Tooltip title="CAS access required — result sharing is not available" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('resSharing')}</span></Tooltip>
                            : isCancelled
                            ? <Tooltip title="Search was cancelled — result sharing is not available" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('resSharing')}</span></Tooltip>
                            : isFailed
                            ? <Tooltip title="Search failed — result sharing is not available" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('resSharing')}</span></Tooltip>
                            : isRunning
                            ? <Tooltip title="Search is in progress — available after completion" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('resSharing')}</span></Tooltip>
                            : <Link href="#resultSharing" title={t('resSharing')} className={"appLink appLink"} onClick={(e) => handleScroll(e, 'resultSharing')}>
                                {t('resSharing')}
                            </Link>
                        }
                        { seqSummary && seqSummary.type !== "GqWfMerge" && seqSummary.type !== "GqWfSeqSearch" && seqSummary.type !== "GqWfAlndbCopy" && !isCmNoAccess && !isCasOnly &&
                        <span>
                        <span className={classes.headerPipe + " appTextColor"}>|</span>
                        {isCancelled
                            ? <Tooltip title="Search was cancelled — alert setting is not available" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('alertSetting')}</span></Tooltip>
                            : isFailed
                            ? <Tooltip title="Search failed — alert setting is not available" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('alertSetting')}</span></Tooltip>
                            : isRunning
                            ? <Tooltip title="Search is in progress — available after completion" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('alertSetting')}</span></Tooltip>
                            : isCasWithOthers
                            ? <Tooltip title="Alerts will run against non-CAS databases only. CAS databases have been excluded." placement="top"><Link href="#alertSettings" className={"appLink appLink"} onClick={(e) => handleScroll(e, 'alertSettings')}>{t('alertSetting')}</Link></Tooltip>
                            : <Link href="#alertSettings" title={t('alertSetting')} className={"appLink appLink"} onClick={(e) => handleScroll(e, 'alertSettings')} >
                                {t('alertSetting')}
                            </Link>
                        }
                        </span>
                        }
                        { isCmNoAccess &&
                        <span>
                        <span className={classes.headerPipe + " appTextColor"}>|</span>
                        <Tooltip title="CM access required - alerts deactivated" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('alertSetting')}</span></Tooltip>
                        </span>
                        }
                        { isCasOnly && !isCmNoAccess &&
                        <span>
                        <span className={classes.headerPipe + " appTextColor"}>|</span>
                        <Tooltip title="Alerts deactivated — CAS access required." placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>{t('alertSetting')}</span></Tooltip>
                        </span>
                        }
                        { seqSummary && seqSummary.type !== "GqWfAlndbCopy" &&
                            <span>
                                <span className={classes.headerPipe + " appTextColor"}>|</span>
                                <Link href="#" title={t('searchHistory')} className={"appLink appLink"} onClick={(e) => handleScroll(e, 'searchHistoryDiv')}>
                                    {t('searchHistory')}
                                </Link>
                            </span>
                        }
                        <span className={classes.headerPipe + " appTextColor"}>|</span>
                        <Link href="#" title={t('notes')} className={"appLink appLink"} onClick={(e) => handleScroll(e, 'notesDiv')}>
                            {t('notes')}
                        </Link>
                    </Typography>
                </Col>
                <Col lg="12" md="12" sm="12">
                    {/* <h6 className={"appTextColor loginTitle " + (!updateTitle ? 'd-block ' : 'd-none ') + classes.searchTitleText} onClick={(e) => showUpdateTitleText(e)}>{seqSummary && seqSummary.text_label}</h6>
                    <div className={"form-group col-md-6 " + (updateTitle ? 'd-block' : 'd-none')}>
                        <TextInput
                            fullWidth={true}
                            id="searchTitle"
                            name="searchTitle"
                            label={t('nameYourSearch')}
                            variant="outlined"
                            value={titleName ? titleName : ''}
                            // onChange={(e)=>setTitleName(e.target.value)}
                            onChange={(e) => updateTitleName(e)}
                            onKeyDown={updateNewTitle}
                            ref={wrapperRef}
                            error={titleNameErr}
                            helperText={titleNameErr && t('188OnlyAllowed')}
                        />
                    </div> */}
                    <Row>
                        {resultWritable &&
                            <span><img className={"float-left appTextColor loginTitle " + classes.searchTitleText} onClick={e => showUpdateTitleText(e)} src={pencilImg}/>&nbsp;</span>
                        }
                        {resultWritable && updateTitle ?
                            <RenameContainer applyNewName={updateNewTitle}
                                nameRef={titleNameRef}
                                placeHolderText={'Title'}
                                maxLength={188}
                                cancelButtonClass={classes.loginSubmitCancel} setRenameEnabled={setUpdateTitle} />
                            : <h6 className={"appTextColor loginTitle " + classes.searchTitleText} onClick={e => showUpdateTitleText(e)}>{titleNameRef.current}</h6>}
                    </Row>
                    <Row>
                        <Col lg="1" md="1" sm="12" className="pr-0 text-center">
                            <img src={seqSearchImg} alt={seqSummary && seqSummary.text_label} />
                        </Col>
                        <Col lg="10" md="10" sm="12" className="p-0 content" style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography className={(seqSummary ? 'd-block' : 'd-none')}>
                                {/* <img className="float-left mx-3" src={seqSearchImg} alt={t('ImmunoglobulinVariationsFor')}/> */}
                                <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /><span>{t('searchLaunchTitle')} {seqSummary && seqSummary.create_time ? format(new Date(seqSummary.create_time), 'dd-MMM-yyyy') : ''} {t('by')} <b>{seqSummary && seqSummary._owner_full_name}</b>.​</span></Typography>
                            <Typography className={(seqSummary && seqSummary.newstats && seqSummary.newstats.stats && seqSummary.newstats.stats.nbnew === 0) ? 'd-block' : 'd-none'}>
                                <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> <span>{t('nbNew')} 0.</span></Typography>
                            <Typography className={(seqSummary && seqSummary.newstats && seqSummary.newstats.stats && seqSummary.newstats.stats.nbnew > 0) ? 'd-block' : 'd-none'}>
                                {userInfo.enableReactDisc === true && !isCmNoAccess && !isCasNoAccess &&
                                    <span><RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> {t('nbNew')} {seqSummary && seqSummary.newstats && seqSummary.newstats.stats && seqSummary.newstats.stats.nbnew ? seqSummary.newstats.stats.nbnew : 0} [<a href={process.env.REACT_APP_BASE_URL + "fulltext/index.html#/discover/wf:" + workflowId + ".resdb/alert"} target="_blank" rel="noreferrer">Results</a>] [<a href={process.env.REACT_APP_BASE_URL + "query?do=gqworkflow.show_result&workflow=id:" + workflowId + "&workflow_output_name=newres.coll&group=s.PN&nbingroup=1&group_sort=-RIQ,-RID,-RI"} target="_blank" rel="noreferrer">Results - Classic</a>].</span>
                                }
                                {userInfo.enableReactDisc !== true && !isCmNoAccess && !isCasNoAccess &&
                                    <span><RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> {t('nbNew')} {seqSummary && seqSummary.newstats && seqSummary.newstats.stats && seqSummary.newstats.stats.nbnew ? seqSummary.newstats.stats.nbnew : 0} [<a href={process.env.REACT_APP_BASE_URL + "resultsummNew/index.html#/resbrowse/wf:" + workflowId + ".resdb/alert/1"} target="_blank" rel="noreferrer">Results</a>] [<a href={process.env.REACT_APP_BASE_URL + "query?do=gqworkflow.show_result&workflow=id:" + workflowId + "&workflow_output_name=newres.coll&group=s.PN&nbingroup=1&group_sort=-RIQ,-RID,-RI"} target="_blank" rel="noreferrer">Results - Classic</a>].</span>
                                }
                                {isCmNoAccess &&
                                    <span><RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> {t('nbNew')} {seqSummary && seqSummary.newstats && seqSummary.newstats.stats && seqSummary.newstats.stats.nbnew ? seqSummary.newstats.stats.nbnew : 0}.</span>
                                }
                                {isCasNoAccess && !isCmNoAccess &&
                                    <span><RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> {t('nbNew')} {seqSummary && seqSummary.newstats && seqSummary.newstats.stats && seqSummary.newstats.stats.nbnew ? seqSummary.newstats.stats.nbnew : 0}.</span>
                                }
                            </Typography>
                            <Typography className={(seqSummary && seqSummary.newstats && seqSummary.newstats.stats && seqSummary.newstats.stats.nbchanged === 0) ? 'd-block' : 'd-none'}>
                                <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> <span>{t('nbChanged')} 0.</span></Typography>
                            <Typography className={(seqSummary && seqSummary.newstats && seqSummary.newstats.stats && seqSummary.newstats.stats.nbchanged > 0) ? 'd-block' : 'd-none'}>
                                {userInfo.enableReactDisc === true && !isCmNoAccess && !isCasNoAccess &&
                                    <span>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    {t('nbChanged')} {seqSummary && seqSummary.newstats && seqSummary.newstats.stats && seqSummary.newstats.stats.nbchanged ? seqSummary.newstats.stats.nbchanged : 0} [<a href={process.env.REACT_APP_BASE_URL + "fulltext/index.html#/discover/wf:" + workflowId + ".resdb/alertChanged"} target="_blank" rel="noreferrer">Results</a>] [<a href={process.env.REACT_APP_BASE_URL + "query?do=gqworkflow.show_result&workflow=id:" + workflowId + "&workflow_output_name=changedres.coll&group=s.PN&nbingroup=1&group_sort=-RIQ,-RID,-RI"} target="_blank" rel="noreferrer">Results - Classic</a>].</span>
                                }
                                {isCmNoAccess &&
                                    <span>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    {t('nbChanged')} {seqSummary && seqSummary.newstats && seqSummary.newstats.stats && seqSummary.newstats.stats.nbchanged ? seqSummary.newstats.stats.nbchanged : 0}.</span>
                                }
                                {isCasNoAccess && !isCmNoAccess &&
                                    <span>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    {t('nbChanged')} {seqSummary && seqSummary.newstats && seqSummary.newstats.stats && seqSummary.newstats.stats.nbchanged ? seqSummary.newstats.stats.nbchanged : 0}.</span>
                                }
                            </Typography>
                            {seqSummary && seqSummary.type !== "GqWfSearchFT" && seqSummary.statistics && seqSummary.statistics.stats && (() => {
                                let maxreachedid = seqSummary.statistics.stats.maxreachedid || [];
                                if (seqSummary.type === "GqWfMerge" && mergeSummary) {
                                    const groupA = mergeSummary.groupA || [];
                                    const groupB = mergeSummary.groupB || [];
                                    const allResolved = [...groupA, ...groupB].every(m => m.memberType !== undefined);
                                    if (allResolved) {
                                        const cmNoSeqPrefixes = [];
                                        let cmCountA = 0;
                                        groupA.forEach(member => {
                                            if (member.memberType === 'GqWfCmSearch') {
                                                cmCountA++;
                                                if (member.isCmNoSeq) cmNoSeqPrefixes.push(`GroupA_CM${cmCountA}_`);
                                            }
                                        });
                                        let cmCountB = 0;
                                        groupB.forEach(member => {
                                            if (member.memberType === 'GqWfCmSearch') {
                                                cmCountB++;
                                                if (member.isCmNoSeq) cmNoSeqPrefixes.push(`GroupB_CM${cmCountB}_`);
                                            }
                                        });
                                        if (cmNoSeqPrefixes.length > 0) {
                                            maxreachedid = maxreachedid.filter(id => !cmNoSeqPrefixes.some(prefix => id.startsWith(prefix)));
                                        }
                                    }
                                }
                                return maxreachedid.length > 0 ? (
                                    <Typography className='d-block'>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                        <span>
                                            <span style={{color: 'RED'}}>WARNING</span>: {t('maxReachedId')}{maxreachedid.join(' ')}
                                        </span>
                                    </Typography>
                                ) : null;
                            })()}
                            {seqSummary && seqSummary.type === "GqWfCmSearch" && seqSummary.statistics && seqSummary.statistics.stats &&
                                <Typography className={(seqSummary.statistics.stats.maxreached && parseInt(seqSummary.statistics.stats.maxreached) > 0 && (!seqSummary.statistics.stats.maxreachedid || seqSummary.statistics.stats.maxreachedid.length === 0)) ? 'd-block' : 'd-none'}>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <span>
                                        <span style={{color: 'RED'}}>WARNING</span>: {t('cmMaxReached')}{seqSummary && seqSummary.statistics && seqSummary.statistics.stats && seqSummary.statistics.stats.maxreached ? seqSummary.statistics.stats.maxreached : ''}
                                    </span>
                                </Typography>
                            }
                            <Typography className={(seqShare && seqShare.sharedNames ? 'd-block' : 'd-none')}>
                                <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> <span>{t('sharedWithTitle')} {seqShare && seqShare.sharedNames}
                                    {isCmNoAccess
                                        ? <Tooltip title="CM access required" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>({t('shareSettings')}).</span></Tooltip>
                                        : isCasNoAccess
                                        ? <Tooltip title="CAS access required" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>({t('shareSettings')}).</span></Tooltip>
                                        : <a href="#" onClick={(e) => handleScroll(e, 'resultSharing')}>({t('shareSettings')}).</a>
                                    }</span></Typography>
                            <Typography className={(alarmSetting && alarmSetting.is_created && !isCmNoAccess && !isCasOnly ? 'd-block' : 'd-none')}>
                                <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                <span>{t('searchRepeatAutomatic')} {alarmSetting && alarmSetting.is_created && Constant['alertOptions'][alarmSetting.relaunch_interval]} {t('emailGoingTo')} {alarmSetting && alarmSetting.email}{t('alarmSettingText2')} <a href="#" onClick={(e) => handleScroll(e, 'alertSettings')}>({t('alertSettings')}).</a></span></Typography>
                            <Typography className={(alarmSetting && alarmSetting.is_created && isCmNoAccess ? 'd-block' : 'd-none')}>
                                <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                <span style={{color: '#999'}}>{t('searchRepeatAutomatic')} {alarmSetting && alarmSetting.is_created && Constant['alertOptions'][alarmSetting.relaunch_interval]} {t('emailGoingTo')} {alarmSetting && alarmSetting.email}{t('alarmSettingText2')} (CM access required - alert deactivated).</span></Typography>
                            <Typography className={(alarmSetting && alarmSetting.is_created && isCasOnly && !isCmNoAccess ? 'd-block' : 'd-none')}>
                                <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                <span style={{color: '#999'}}>{t('searchRepeatAutomatic')} {alarmSetting && alarmSetting.is_created && Constant['alertOptions'][alarmSetting.relaunch_interval]} {t('emailGoingTo')} {alarmSetting && alarmSetting.email}{t('alarmSettingText2')} (CAS access required - alert deactivated).</span></Typography>
                            {isCasOnly && !isCmNoAccess &&
                                <Typography className="d-block mt-1">
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <span style={{color: '#cc0000'}}>
                                        You don't have CAS access. This workflow uses CAS databases only — results and alerts are not available.
                                    </span>
                                </Typography>
                            }
                            {isCasWithOthers && !isCmNoAccess &&
                                <Typography className="d-block mt-1">
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <span style={{color: '#cc6600'}}>
                                        You don't have CAS access. This workflow includes both CAS and non-CAS databases — results are not available. Alerts will run against non-CAS databases only.
                                    </span>
                                </Typography>
                            }
                        </Col>
                    </Row>
                    <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>                    
                        {archiveMsg && 
                        <Row>
                            <Col lg="12" md="12" sm="12" className="pr-0 content">
                                <h6 className={"failedIconColor "}>Archived</h6>
                                <Typography className="appTextFont ml-3">{t('archiveMsg')}</Typography>
                                <Typography className="appTextFont ml-3">{t('archiveMsg1')} <a href={"mailto:" + supportMail}>{supportMail}</a> {t('archiveMsg2')}</Typography>
                                <Typography className="appTextFont ml-3">{t('archiveMsg3')}</Typography>
                                <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                            </Col>
                        </Row>
                    
                        }
                    <Row>
                        {seqSummary && seqSummary.type !== "GqWfMerge" && seqSummary.type !== "GqWfSearchFT" && seqSummary.type !== "GqWfAlndbCopy" &&
                        <Col lg="12" md="12" sm="12" className="pr-0 content">
                            {!(seqSummary && seqSummary.type === "GqWfCmSearch" && cmNoSeq) && <span>
                            <h6 className={"appTextColor loginTitle"}>{t('query')}</h6>
                            {querySeqData === '' ? (
                                <Typography className="appTextFont ml-3">
                                    Query sequence data is not yet available. The search may still be running.
                                </Typography>
                            ) : querySeqData && querySeqData.trim().startsWith('<!DOCTYPE html>') ? (
                                <Typography className="appTextFont ml-3">
                                    Unable to retrieve query sequence data.
                                </Typography>
                            ) : querySeqData && querySeqData.trim().length > 0 && !querySeqData.trim().match(/^>[^\n]*\n*$/) ? (
                                <>
                                    <Typography className="appTextFont ml-3">
                                        These {seqSummary && seqSummary.statistics && seqSummary.statistics.stats && seqSummary.statistics.stats.nboqueries} <span className="text-lowercase">{seqSummary && seqSummary.qdb_seq_type}</span> sequences {t('usedInSearch')}
                                        {isCmNoAccess
                                            ? <Tooltip title="CM access required" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}} className="ml-3">Download</span></Tooltip>
                                            : <Link className={"appLink ml-3"} href="#" onClick={(e) => downloadQuerySeq(e)}>Download</Link>
                                        }
                                        {isCmNoAccess
                                            ? <Tooltip title="CM access required" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}} className="ml-3">Copy to Clipboard</span></Tooltip>
                                            : <Link className={"appLink ml-3"} href="#" onClick={(e) => { e.preventDefault(); copyToClipboard(); }}>Copy to Clipboard</Link>
                                        }
                                    </Typography>
                                    
                                    <div style={{ marginLeft: '16px', marginTop: '10px', marginBottom: '10px' }}>
                                        <pre style={{ 
                                            borderRadius: '4px', 
                                            maxHeight: '300px',
                                            overflow: 'auto',
                                            whiteSpace: 'pre-wrap',
                                            wordWrap: 'break-word',
                                            backgroundColor: toggle ? '#f5f5f5' : '#2a2a2a',
                                            color: toggle ? '#212529' : '#ffffffff',
                                            padding: '12px'
                                        }}>
                                            {querySeqData}
                                        </pre>
                                    </div>
                                </>
                            ) : (
                                <Typography className="appTextFont ml-3">
                                    No sequences have been used in this search.
                                </Typography>
                            )}
                            <br />
                            </span>}
                            {<span>
                            <h6 className={"appTextColor loginTitle"}>{t('subjDB')}</h6>
                            {seqSummary && seqSummary.params && seqSummary.params.seqlenrange_low && seqSummary.params.seqlenrange_high && (seqSummary.type_label === 'IP' || seqSummary.type_label === 'VM' || seqSummary.type_label === 'CM') &&
                                <Typography className="appTextFont ml-3">
                                    Sequences with length less than {UtilsService.numberWithCommas(seqSummary.params.seqlenrange_low)} or more than {UtilsService.numberWithCommas(seqSummary.params.seqlenrange_high)} are not searched.
                                </Typography>
                            }
                            {seqSummary && seqSummary.type_label === 'AB IP' &&
                                <Typography className="appTextFont ml-3">
                                    Protein Databases ({UtilsService.numberWithCommas(seqSummary.sdb_nb_sequences)} sequences):
                                </Typography>
                            }

                            {seqSummary && seqSummary.sdb_db_list && Object.keys(seqSummary.sdb_db_list).map((dbVal, i) => {
                                const entry = seqSummary.sdb_db_list[dbVal];
                                if (!entry) return null;
                                const parsedDate = entry.update_time ? new Date(entry.update_time) : null;
                                return (
                                    <Row className="ml-1 mb-1" key={i} style={{ lineHeight: '1.8' }}>
                                        <Col lg="6" md="6" className="pr-0 content">
                                            <Typography style={{ wordBreak: 'break-word' }}>
                                                <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> {fieldConfig.getDatabaseName(entry.title || dbVal)}</Typography>
                                        </Col>
                                        <Col lg="2" md="2" className="pr-0 content">
                                            <Typography>{entry.version}</Typography>
                                        </Col>
                                        <Col lg="2" md="2" className="pr-0 content">
                                            <Typography>
                                                {parsedDate && !isNaN(parsedDate) ? format(parsedDate, 'dd-MMM-yyyy') : ''}
                                            </Typography>
                                        </Col>
                                        <Col lg="2" md="2" className={"pr-0 " + (classes.content)}>

                                            {entry.current_update_time && (entry.update_time === entry.current_update_time) &&
                                                <Typography className="text-success">{t('currentVersion')}</Typography>
                                            }
                                            {entry.current_update_time && (entry.update_time !== entry.current_update_time) &&
                                                <Typography className="failedTextColor">{t('updateAvailable')}</Typography>
                                            }

                                        </Col>
                                    </Row>
                                )
                            })}
                            </span>}
                            {!(seqSummary && seqSummary.type === "GqWfCmSearch" && cmNoSeq) && <span>
                            <h6 className={"appTextColor loginTitle mt-3"}>{t('searchStrategy')}</h6>
                            <Col lg="12" md="12" className={"pr-0 content"}>
                                <Typography >
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> The sequence comparison algorithm used is <span className="text-capitalize">{seqSummary && seqSummary.params && Constant['searchStrategies'][seqSummary.params.strat_name] ? Constant['searchStrategies'][seqSummary.params.strat_name] : ''}.</span>​</Typography>
                            </Col>
                            <Col lg="12" md="12" className={"pr-0 content " + (seqSummary && seqSummary.params
                                && seqSummary.params.nucandprot !== "on" && seqSummary.qdb_seq_type === "NUCLEOTIDE"
                                && (seqSummary.params.strat_name === "kerr" || seqSummary.params.strat_name === "hash")
                                && (seqSummary.params.match_tu === "0" || seqSummary.params.match_tu === false) ? 'd-block' : 'd-none')}>
                                <Typography >
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> Thymine (T) doesn't align with uracil (U).</Typography>
                            </Col>
                            <Col lg="12" md="12" className={"pr-0 content " + (seqSummary && seqSummary.params
                                && seqSummary.params.nucandprot !== "on" && seqSummary.qdb_seq_type === "NUCLEOTIDE" && seqSummary.params.strat_name !== "blast"
                                && (seqSummary.params.frame_sel === "for" || seqSummary.params.frame_sel === "rev") ? 'd-block' : 'd-none')}>
                                <Typography >
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> Alignment Frame Selection: {seqSummary.params.frame_sel === "for" ? "Forward" : "Reverse"}.</Typography>
                            </Col>
                            <Col lg="12" md="12" className={"pr-0 content " + (seqSummary && seqSummary.params && (seqSummary.params.strat_name === "kerr" || seqSummary.params.strat_name === "hash") ? 'd-block' : 'd-none')}>
                                <Typography >
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> This algorithm fits the entire shorter sequence (query or subject) into the longer one.</Typography>
                                {seqSummary && seqSummary.params && !seqSummary.params.isABModule && <Typography>
                                     <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor " /> Results are required to have at least {seqSummary && seqSummary.params.strat_genepast_perc_id}% identity over the
                                     {seqSummary && seqSummary.params && Constant['genePastItemsText'][seqSummary.params.strat_genepast_perc_id_over]}.​</Typography>}
                                {seqSummary && seqSummary.params && seqSummary.params.isABModule && <Typography>
                                     <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor " /> Results are required to have at least {seqSummary && seqSummary.params.strat_genepast_perc_id_hc ? seqSummary.params.strat_genepast_perc_id_hc : seqSummary.params.strat_genepast_perc_id}% identity
                                     over the Heavy Chain Sequence, {seqSummary && seqSummary.params.strat_genepast_perc_id_lc ? seqSummary.params.strat_genepast_perc_id_lc : seqSummary.params.strat_genepast_perc_id}% identity over the Light Chain Sequence.​</Typography>}
                                {seqSummary && seqSummary.params && !seqSummary.params.isABModule && seqSummary.type !== "GqWfCmSearch" && <Typography >
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />  For each query sequence the {seqSummary && seqSummary.params && seqSummary.params.best_hit_keep_max ? UtilsService.numberWithCommas(seqSummary.params.best_hit_keep_max) : '0'} best alignments are reported.​</Typography>}
                                {seqSummary && seqSummary.params && seqSummary.type === "GqWfCmSearch" && <Typography >
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />  {seqSummary && seqSummary.params && seqSummary.params.best_hit_keep_max ? UtilsService.numberWithCommas(seqSummary.params.best_hit_keep_max) : '0'} best alignments are reported.​</Typography>}
                            </Col>
                            <Col lg="12" md="12" className={"pr-0 content " + (seqSummary && seqSummary.params && seqSummary.params.strat_name === "blast" ? 'd-block' : 'd-none')} >
                                {/* <div className="content">
                                    <Typography >
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> This algorithm fits the entire shorter sequence (query or subject) into the longer one.​</Typography>
                                </div> */}
                                <div className={"pr-0 content " + (seqSummary && seqSummary.runstats && seqSummary.runstats.comp_mode === "NUCLEOTIDE-NUCLEOTIDE" ? 'd-block' : 'd-none')}>
                                    {/* <Typography >
                                            <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> word size is {seqSummary && seqSummary.params.strat_blast_word_size_nuc}.
										</Typography> */}
                                    <Typography >
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                        Results are obtained using the <span className="text-uppercase">{seqSummary && seqSummary.params.strat_blast_scoring_matrix_nuc ? seqSummary.params.strat_blast_scoring_matrix_nuc : "NUC.3.1"}</span> scoring matrix with a word size of {seqSummary && seqSummary.params.strat_blast_word_size_nuc} and an expected cutoff of {seqSummary && seqSummary.params.strat_blast_eval_cutoff}.
                                    </Typography>
                                    {/* <Typography className="text-lowercase">
                                            <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor " /> scoring matrix is <span className="text-uppercase">{seqSummary && seqSummary.params.strat_blast_scoring_matrix_nuc ? seqSummary.params.strat_blast_scoring_matrix_nuc:"NUC.3.1"}</span>​.</Typography> */}

                                </div>
                                <div className={"pr-0 content " + (seqSummary && seqSummary.runstats && Constant['nucleotideDB'].includes(seqSummary.runstats.comp_mode) ? 'd-block' : 'd-none')}>
                                    {/* <Typography >
                                            <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> word size is {seqSummary && seqSummary.params.strat_blast_word_size_pro}.​</Typography>
                                        <Typography className="text-lowercase">
                                            <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor " /> scoring matrix is <span className="text-uppercase">{seqSummary && seqSummary.params.strat_blast_scoring_matrix_pro ? seqSummary.params.strat_blast_scoring_matrix_pro:"BLOSUM62"}</span>.​</Typography> */}
                                    <Typography >
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                        Results are obtained using the <span className="text-uppercase">{seqSummary && seqSummary.params.strat_blast_scoring_matrix_pro ? seqSummary.params.strat_blast_scoring_matrix_pro : "BLOSUM62"}</span> scoring matrix with a word size of {seqSummary && seqSummary.params.strat_blast_word_size_pro} and an expected cutoff of {seqSummary && seqSummary.params.strat_blast_eval_cutoff}.
                                    </Typography>

                                </div>
                                <div className={"pr-0 content " + (seqSummary && seqSummary.runstats && seqSummary.runstats.comp_mode === "NUCLEOTIDE-MIX" ? 'd-block' : 'd-none')}>
                                    {/* <Typography >
                                            <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> word size is {seqSummary && seqSummary.params.strat_blast_word_size_nuc} for nucleotide and {seqSummary && seqSummary.params.strat_blast_word_size_pro} for protein.​</Typography>
                                        <Typography className="text-lowercase">
                                            <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor " /> scoring matrix is <span className="text-uppercase">{seqSummary && seqSummary.params.strat_blast_scoring_matrix_nuc ? seqSummary.params.strat_blast_scoring_matrix_nuc :"NUC.3.1"}</span> for nucleotide and <span className="text-uppercase">{seqSummary && seqSummary.params.strat_blast_scoring_matrix_pro ? seqSummary.params.strat_blast_scoring_matrix_pro:"BLOSUM62"}</span> for protein.​</Typography> */}
                                    <Typography >
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                        Results are obtained using the <span className="text-uppercase">{seqSummary && seqSummary.params.strat_blast_scoring_matrix_nuc ? seqSummary.params.strat_blast_scoring_matrix_nuc : "NUC.3.1"}</span> for nucleotide and <span className="text-uppercase">{seqSummary && seqSummary.params.strat_blast_scoring_matrix_pro ? seqSummary.params.strat_blast_scoring_matrix_pro : "BLOSUM62"}</span> for protein scoring matrix with a word size of {seqSummary && seqSummary.params.strat_blast_word_size_nuc} for nucleotide and {seqSummary && seqSummary.params.strat_blast_word_size_pro} for protein and an expected cutoff of {seqSummary && seqSummary.params.strat_blast_eval_cutoff}.
                                    </Typography>

                                </div>
                                <div className="content">
                                    {/* <Typography >
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> e-val cutoff is {seqSummary && seqSummary.params.strat_blast_eval_cutoff}.​</Typography> */}
                                    <Typography className={seqSummary && seqSummary.params.strat_blast_hsp === "on" ? 'd-block' : 'd-none'}>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> HSPs are processed​.</Typography>
                                    <Typography className={seqSummary && seqSummary.params.strat_blast_hsp !== "on" ? 'd-block' : 'd-none'}>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> HSPs are not processed​.</Typography>
                                    {seqSummary && seqSummary.params && !seqSummary.params.isABModule &&  <Typography >
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />  For each query sequence the {seqSummary && seqSummary.params && seqSummary.params.best_hit_keep_max ? UtilsService.numberWithCommas(seqSummary.params.best_hit_keep_max) : '0'} best alignments are reported.​</Typography>}
                                </div>
                            </Col>
                            <Col lg="12" md="12" className={"pr-0 content " + (seqSummary && seqSummary.params && seqSummary.params.strat_name === "sw" ? 'd-block' : 'd-none')} >
                                <div className={"pr-0 content " + (seqSummary && seqSummary.runstats && seqSummary.runstats.comp_mode === "NUCLEOTIDE-NUCLEOTIDE" ? 'd-block' : 'd-none')}>
                                    <Typography >
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> gap open / extension panelties are {seqSummary && seqSummary.params.strat_sw_gapo_nuc} / {seqSummary && seqSummary.params.strat_sw_gape_nuc}.</Typography>
                                    <Typography className="text-lowercase">
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor " /> scoring matrix is <span className="text-uppercase">{seqSummary && seqSummary.params.strat_sw_scoring_matrix_nuc ? seqSummary.params.strat_sw_scoring_matrix_nuc : "NUC.3.1"}​</span>.</Typography>
                                </div>
                                <div className={"pr-0 content " + (seqSummary && seqSummary.runstats && Constant['nucleotideDB'].includes(seqSummary.runstats.comp_mode) ? 'd-block' : 'd-none')}>
                                    <Typography >
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> gap open / extension panelties are {seqSummary && seqSummary.params.strat_sw_gapo_nuc} / {seqSummary && seqSummary.params.strat_sw_gape_nuc} for nucleotide, and {seqSummary && seqSummary.params.strat_sw_gapo_pro} / {seqSummary && seqSummary.params.strat_sw_gape_pro} for protein.​</Typography>
                                    <Typography>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor " /> scoring matrix is <span className="text-uppercase">{seqSummary && seqSummary.params.strat_sw_scoring_matrix_pro ? seqSummary.params.strat_sw_scoring_matrix_pro : "BLOSUM62"}</span>​.</Typography>
                                </div>
                                <div className={"pr-0 content " + (seqSummary && seqSummary.runstats && seqSummary.runstats.comp_mode === "NUCLEOTIDE-MIX" ? 'd-block' : 'd-none')}>
                                    <Typography>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor " /> scoring matrix is <span className="text-uppercase">{seqSummary && seqSummary.params.strat_sw_scoring_matrix_nuc ? seqSummary.params.strat_sw_scoring_matrix_nuc : "NUC.3.1"}</span> for nucleotide, and <span className="text-uppercase">{seqSummary && seqSummary.params.strat_sw_scoring_matrix_pro ? seqSummary.params.strat_sw_scoring_matrix_pro : "BLOSUM62"}</span> for protein.​</Typography>
                                </div>
                                <div className="content">
                                    <Typography >
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> score cutoff is {seqSummary && seqSummary.params.strat_sw_score_cutoff}.​</Typography>
                                    <Typography >
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />  For each query sequence the {seqSummary && seqSummary.params && seqSummary.params.best_hit_keep_max ? UtilsService.numberWithCommas(seqSummary.params.best_hit_keep_max) : '0'} best alignments are reported.​</Typography>
                                </div>
                            </Col>
                            <Col lg="12" md="12" className={"pr-0 content " + (seqSummary && seqSummary.params && seqSummary.params.strat_name === "fragment" ? 'd-block' : 'd-none')}>
                                <div className="content">
                                    <Typography >
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> This algorithm fits the entire shorter sequence (query or subject) into the longer one.​</Typography>
                                </div>
                                <div className={"pr-0 content " + (seqSummary && seqSummary.runstats && seqSummary.runstats.comp_mode === "NUCLEOTIDE-NUCLEOTIDE" ? 'd-block' : 'd-none')}>
                                    {/* <Typography >
                                            <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> alignments with less than {seqSummary && seqSummary.params.strat_fragment_perc_id_nuc}% identity over window size of {seqSummary && seqSummary.params.strat_fragment_window_length_nuc} are discarded.</Typography> */}
                                    <Typography>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor " /> Results are required to have at least {seqSummary && seqSummary.params.strat_fragment_perc_id_nuc}% identity over any stretch of {seqSummary && seqSummary.params && seqSummary.params.strat_fragment_window_length_nuc} nucleotides.​</Typography>
                                </div>
                                <div className={"pr-0 content " + (seqSummary && seqSummary.runstats && Constant['nucleotideDB'].includes(seqSummary.runstats.comp_mode) && seqSummary.runstats.comp_mode !== "NUCLEOTIDE-MIX" ? 'd-block' : 'd-none')}>
                                    {/* <Typography >
                                            <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /> alignments with less than {seqSummary && seqSummary.params.strat_fragment_perc_id_pro}% identity over window size of {seqSummary && seqSummary.params.strat_fragment_window_length_pro} are discarded.​</Typography> */}
                                    <Typography>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor " /> Results are required to have at least {seqSummary && seqSummary.params.strat_fragment_perc_id_pro}% identity over any stretch of {seqSummary && seqSummary.params && seqSummary.params.strat_fragment_window_length_pro} amino acids.​</Typography>
                                </div>
                                <div className={"pr-0 content " + (seqSummary && seqSummary.runstats && seqSummary.runstats.comp_mode === "NUCLEOTIDE-MIX" ? 'd-block' : 'd-none')} >
                                    {seqSummary && seqSummary.params.strat_fragment_perc_id_nuc && <Typography>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor " /> Results are required to have at least {seqSummary && seqSummary.params.strat_fragment_perc_id_nuc}% identity over any stretch of {seqSummary && seqSummary.params && seqSummary.params.strat_fragment_window_length_nuc} nucleotides.​</Typography>}
                                    {seqSummary && seqSummary.params.strat_fragment_perc_id_pro && <Typography>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor " /> Results are required to have at least {seqSummary && seqSummary.params.strat_fragment_perc_id_pro}% identity over any stretch of {seqSummary && seqSummary.params && seqSummary.params.strat_fragment_window_length_pro} amino acids.​</Typography>}

                                </div>
                                <div className="content">
                                    <Typography >
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />  For each query sequence the {seqSummary && seqSummary.params && seqSummary.params.best_hit_keep_max ? UtilsService.numberWithCommas(seqSummary.params.best_hit_keep_max) : '0'} best alignments are reported.​</Typography>
                                </div>
                            </Col>
                            <Col lg="12" md="12" className={"pr-0 content " + (seqSummary && seqSummary.params && seqSummary.params.strat_name === "motif" ? 'd-block' : 'd-none')}>
                                <Typography >
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />  For each query sequence the {seqSummary && seqSummary.params && seqSummary.params.best_hit_keep_max ? UtilsService.numberWithCommas(seqSummary.params.best_hit_keep_max) : '0'} best alignments are reported.​</Typography>
                            </Col>
                            <br clear="all" />
                            <h6 className={"appTextColor loginTitle"}>{t('techData')}</h6>
                            <Typography className="appTextFont ml-3"><b>{t('runTimes')}</b></Typography>
                            {seqSummary && seqSummary.create_time &&
                            <Col lg="12" md="12" className="pr-0 content">
                                <Typography>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /><span>{t('analysisSubmitted')} {format(new Date(seqSummary.create_time), 'dd-MMM-yyyy')} at {format(new Date(seqSummary.create_time), 'hh:mmaaa').toUpperCase()} (EST)</span>
                                </Typography>
                            </Col>}
                            {runStatsData && runStatsData.totalRuntime != null &&
                            <Col lg="12" md="12" className="pr-0 content">
                                <Typography>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <span style={{ display: 'inline-flex' }}>
                                        <span style={{ minWidth: '260px' }}>{t('totalRuntime')}</span><span>{runStatsData.totalRuntime}</span>
                                    </span>
                                </Typography>
                                {runStatsData.searchRunningTime != null &&
                                <Typography style={{ marginLeft: '30px' }}>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <span style={{ display: 'inline-flex' }}>
                                        <span style={{ minWidth: '230px' }}>{t('searchRunningTime')}</span><span>{runStatsData.searchRunningTime}</span>
                                    </span>
                                </Typography>}
                                {runStatsData.resultPreparationTime != null &&
                                <Typography style={{ marginLeft: '30px' }}>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <span style={{ display: 'inline-flex' }}>
                                        <span style={{ minWidth: '230px' }}>{t('resultPreparationTime')}</span><span>{runStatsData.resultPreparationTime}</span>
                                    </span>
                                </Typography>}
                                {runStatsData.textIndexingTime != null &&
                                <Typography style={{ marginLeft: '30px' }}>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <span style={{ display: 'inline-flex' }}>
                                        <span style={{ minWidth: '230px' }}>{t('textIndexingTime')}</span><span>{runStatsData.textIndexingTime}</span>
                                    </span>
                                </Typography>}
                            </Col>}
                            <Typography className="appTextFont ml-3" ><b>{t('storage')}</b></Typography>
                            <Col lg="12" md="12" className="pr-0 content">
                                <Typography >
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <div className={(userInfo && userInfo.current_user.user_class_name === "adminium" && !isCmNoAccess ? ' d-block' : 'd-none')}>
                                        <Link className={"appLink"} href="#" onClick={(e) => downloadTechLog(e, workflowId)}>Search Id {workflowId}</Link> consumes {seqSummary && seqSummary.usedSpace} Mb of server disk space​.
                                    </div>
                                    <div className={(userInfo && userInfo.current_user.user_class_name === "adminium" && isCmNoAccess ? ' d-block' : 'd-none')}>
                                        <Tooltip title="CM access required" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>Search Id {workflowId}</span></Tooltip> consumes {seqSummary && seqSummary.usedSpace} Mb of server disk space​.
                                    </div>
                                    <div className={(userInfo && userInfo.current_user.user_class_name !== "adminium" ? ' d-block' : 'd-none')}>
                                        <span className={"appLink" + (userInfo && userInfo.current_user.user_class_name !== "adminium" ? 'd-block' : 'd-none')}>Search Id {workflowId}</span> consumes {seqSummary && seqSummary.usedSpace} Mb of server disk space​.
                                    </div>
                                </Typography>
                            </Col>
                            <br clear="all" />
                            { seqSummary.statistics &&
                            <span>
                            <h6 className={"appTextColor loginTitle"}>{t('statistics')}</h6>
                            <Col lg="12" md="12" className="pr-0 content mb-2">
                                <Typography >
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <div>
                                       Number of queries without hits: {seqSummary && seqSummary.statistics.stats.querynohits} &nbsp;&nbsp;
                                        {seqSummary && seqSummary.statistics.stats.querynohits > 0 && !isCmNoAccess &&
                                            <Link className={"appLink"} href="#" onClick={(e) => downloadQueryNoHits(e, workflowId)}>Download queries without hits</Link>
                                        }
                                        {seqSummary && seqSummary.statistics.stats.querynohits > 0 && isCmNoAccess &&
                                            <Tooltip title="CM access required" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>Download queries without hits</span></Tooltip>
                                        }
                                    </div>
                                    { seqSummary && seqSummary.statistics.stats.querynohits > 0 &&
                                    <span>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <div>
                                       Query ID's without hits are: {seqSummary && seqSummary.statseq}
                                    </div>
                                    </span>}
                                </Typography>
                            </Col>
                            </span>
                            }
                            </span>
                            }

                        </Col>}

                        { seqSummary && seqSummary.type === "GqWfMerge" &&
                        <Col lg="12" md="12" sm="12" className="pr-0 content">
                            <h6 className={"appTextColor loginTitle"}>{t('mergeStrategy')}</h6>
                            <Typography className="appTextFont ml-3"> {t('mergeInfo')}{mergeSummary && mergeSummary.mergeType}</Typography>
                            <br/>
                            <h7 className={classes.mergeGroupTitle + " appTextColor"}>Group A </h7>

                            <Typography><b>{mergeSummary && mergeSummary.groupA && mergeSummary.groupA.map((d, index)  => (
                                    <div key={index}>
                                    <Typography className="appTextFont ml-3">
                                       {d.click === "Clickable" ? <Link style={{ marginLeft: '25px'}} to={"/searchresseq/"+ encodeURIComponent(d.workflowId)} target="_blank">{d.title}</Link> : <span style={{ marginLeft: '25px'}} >{d.title}</span>}
                                    </Typography>

                                    <Typography className="appTextFont" style={{ marginLeft: '60px'}}> {d.strategyString}</Typography><br/>
                                  </div>))} </b>
                            </Typography>
                             <h7 className={classes.mergeGroupTitle + " appTextColor"}>Group B</h7>
                            <Typography><b>{mergeSummary && mergeSummary.groupB && mergeSummary.groupB.map((d, index)  => (
                                    <div key={index}>
                                    <Typography className="appTextFont ml-3">
                                    {d.click === "Clickable" ? <Link style={{ marginLeft: '25px'}} to={"/searchresseq/"+ encodeURIComponent(d.workflowId)} target="_blank">{d.title}</Link> : <span style={{ marginLeft: '25px'}} >{d.title}</span>}
                                    </Typography>
                                    <Typography className="appTextFont" style={{ marginLeft: '60px'}}> {d.strategyString}</Typography><br/>
                                  </div>))} </b>
                            </Typography>
                             <br clear="all" />
                            <h6 className={"appTextColor loginTitle"}>{t('techData')}</h6>
                            <Typography className="appTextFont ml-3"><b>{t('runTimes')}</b></Typography>
                            {seqSummary && seqSummary.create_time &&
                            <Col lg="12" md="12" className="pr-0 content">
                                <Typography>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /><span>{t('analysisSubmitted')} {format(new Date(seqSummary.create_time), 'dd-MMM-yyyy')} at {format(new Date(seqSummary.create_time), 'hh:mmaaa').toUpperCase()} (EST)</span>
                                </Typography>
                            </Col>}
                            {runStatsData && runStatsData.totalRuntime != null &&
                            <Col lg="12" md="12" className="pr-0 content">
                                <Typography>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <span style={{ display: 'inline-flex' }}>
                                        <span style={{ minWidth: '260px' }}>{t('totalRuntime')}</span><span>{runStatsData.totalRuntime}</span>
                                    </span>
                                </Typography>
                                {runStatsData.searchRunningTime != null &&
                                <Typography style={{ marginLeft: '30px' }}>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <span style={{ display: 'inline-flex' }}>
                                        <span style={{ minWidth: '230px' }}>{t('searchRunningTime')}</span><span>{runStatsData.searchRunningTime}</span>
                                    </span>
                                </Typography>}
                                {runStatsData.resultPreparationTime != null &&
                                <Typography style={{ marginLeft: '30px' }}>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <span style={{ display: 'inline-flex' }}>
                                        <span style={{ minWidth: '230px' }}>{t('resultPreparationTime')}</span><span>{runStatsData.resultPreparationTime}</span>
                                    </span>
                                </Typography>}
                                {runStatsData.textIndexingTime != null &&
                                <Typography style={{ marginLeft: '30px' }}>
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <span style={{ display: 'inline-flex' }}>
                                        <span style={{ minWidth: '230px' }}>{t('textIndexingTime')}</span><span>{runStatsData.textIndexingTime}</span>
                                    </span>
                                </Typography>}
                            </Col>}
                            <Typography className="appTextFont ml-3" ><b>{t('storage')}</b></Typography>
                            <Col lg="12" md="12" className="pr-0 content">
                                <Typography >
                                    <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                    <div className={(userInfo && userInfo.current_user.user_class_name === "adminium" ? ' d-block' : 'd-none')}>
                                        <Link className={"appLink"} href="#" onClick={(e) => downloadTechLog(e, workflowId)}>Search Id {workflowId}</Link> consumes {seqSummary && seqSummary.usedSpace} Mb of server disk space​.
                                    </div>
                                    <div className={(userInfo && userInfo.current_user.user_class_name !== "adminium" ? ' d-block' : 'd-none')}>
                                        <span className={"appLink" + (userInfo && userInfo.current_user.user_class_name !== "adminium" ? 'd-block' : 'd-none')}>Search Id {workflowId}</span> consumes {seqSummary && seqSummary.usedSpace} Mb of server disk space​.
                                    </div>
                                </Typography>
                            </Col>
                            <br clear="all" />
                        </Col>
                        }
                        { seqSummary && seqSummary.type === "GqWfSearchFT" &&
                        <Col lg="12" md="12" sm="12" className="pr-0 content">
                            <h6 className={"appTextColor loginTitle"}>{t('query')}</h6>
                            <Typography className="appTextFont ml-3"> {t('querySearch')}</Typography>
                            
                            <Typography className="appTextFont" style={{ marginLeft: '60px', wordWrap: 'break-word'}} >{ftQuery}</Typography>
                        </Col>
                        }
                        { seqSummary && seqSummary.type === "GqWfCmSearch" && cmQuery &&
                            <Col lg="12" md="12" sm="12" className="pr-0 content">
                                <br />
                                {cmQueryPatterns &&
                                    <>
                                        <h6 className={"appTextColor loginTitle"}>{t('queryPatterns')}</h6>
                                        <Typography className="appTextFont ml-3"> {t('cmQuerySearch')}</Typography>
                                        <Typography className="appTextFont" style={{ marginLeft: '60px', wordWrap: 'break-word'}} >{cmQueryPatterns}</Typography>
                                        <br />
                                    </>
                                }

                                <h6 className={"appTextColor loginTitle"}>{t('subjectPatterns')}</h6>
                                <Typography className="appTextFont ml-3"> {t('cmQuerySearch')}</Typography>
                                <Typography className="appTextFont" style={{ marginLeft: '60px', wordWrap: 'break-word'}} >{cmQuery}</Typography>
                            </Col>
                        }
                        { seqSummary && seqSummary.type === "GqWfAlndbCopy" &&
                            <Col lg="12" md="12" sm="12" className="pr-0 content">
                                <h6 className={"appTextColor loginTitle"}>{t('saveFilteredResult')}</h6>
                                <Col lg="12" md="12" className="pr-0 content mb-2">
                                    {(() => {
                                        const localSeqDbs = [...(seqSummary.params?.nucdbs || []), ...(seqSummary.params?.protdbs || [])];
                                        const isCmNoAccess = (
                                            seqSummary.parent_type === "GqWfCmSearch" ||
                                            localSeqDbs.some(db => /^CAS.*_MS$/.test(db)) ||
                                            (seqSummary.databases || []).some(db => /^CAS.*_MS$/.test(db))
                                        ) && userInfo && userInfo.current_user && !userInfo.current_user.cmAccess;
                                        return (
                                        <>
                                    <Typography className='d-block'>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                        <span>{t('nbOfResults')}</span>
                                        {isCmNoAccess
                                            ? <Tooltip title="Access to these results requires an active subscription to the Chemical Modification Module." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>{seqSummary.total_nb_results}</span></Tooltip>
                                            : isCasNoAccess
                                            ? <Tooltip title="Access to these results requires an active CAS Biosequences subscription." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>{seqSummary.total_nb_results}</span></Tooltip>
                                            : <a href={process.env.REACT_APP_BASE_URL + url.mostRecentTypeUrl.replace('**', workflowId)} target="_blank" rel="noreferrer">{seqSummary.total_nb_results}</a>
                                        }
                                    </Typography>
                                    <Typography className='d-block'>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                        <div className={(seqSummary.res_parent_exist ? ' d-block' : 'd-none')}>
                                            <span>{t('subResult')}</span>
                                            {isCmNoAccess
                                                ? <Tooltip title="Access to these results requires an active subscription to the Chemical Modification Module." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>{seqSummary.res_text_label}</span></Tooltip>
                                                : isCasNoAccess
                                                ? <Tooltip title="Access to these results requires an active CAS Biosequences subscription." placement="top"><span style={{color: '#bbb', cursor: 'not-allowed', fontStyle: 'italic'}}>{seqSummary.res_text_label}</span></Tooltip>
                                                : <a href={process.env.REACT_APP_BASE_URL + url.mostRecentTypeUrl.replace('**', seqSummary.res_parent_id)} target="_blank" rel="noreferrer">{seqSummary.res_text_label}</a>
                                            }
                                        </div>
                                        <div className={(seqSummary.res_parent_exist ? ' d-none' : 'd-block')}>
                                            <span>{t('subResultDeleted')}</span>{seqSummary.res_parent_id + ')'}
                                        </div>
                                    </Typography>
                                    <Typography className='d-block'>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                        <span>{t('subResultFilters')}</span>
                                        {seqSummary.filter_desc}
                                    </Typography>
                                    {seqSummary.vm_filter_desc && seqSummary.vm_filter_desc !== '' &&
                                    <Typography className='d-block'>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                        <span>{t('subResultVmFilters')}</span>
                                        {seqSummary.vm_filter_desc}
                                    </Typography>
                                    }
                                        </>
                                        );
                                    })()}
                                </Col>

                                <br clear="all" />
                                <h6 className={"appTextColor loginTitle"}>{t('techData')}</h6>
                                <Typography className="appTextFont ml-3"><b>{t('runTimes')}</b></Typography>
                                {seqSummary && seqSummary.create_time &&
                                <Col lg="12" md="12" className="pr-0 content">
                                    <Typography>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" /><span>{t('analysisSubmitted')} {format(new Date(seqSummary.create_time), 'dd-MMM-yyyy')} at {format(new Date(seqSummary.create_time), 'hh:mmaaa').toUpperCase()} (EST)</span>
                                    </Typography>
                                </Col>}
                                {runStatsData && runStatsData.totalRuntime != null &&
                                <Col lg="12" md="12" className="pr-0 content">
                                    <Typography>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                        <span style={{ display: 'inline-flex' }}>
                                            <span style={{ minWidth: '260px' }}>{t('totalRuntime')}</span><span>{runStatsData.totalRuntime}</span>
                                        </span>
                                    </Typography>
                                    {runStatsData.searchRunningTime != null &&
                                    <Typography style={{ marginLeft: '30px' }}>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                        <span style={{ display: 'inline-flex' }}>
                                            <span style={{ minWidth: '230px' }}>{t('searchRunningTime')}</span><span>{runStatsData.searchRunningTime}</span>
                                        </span>
                                    </Typography>}
                                    {runStatsData.resultPreparationTime != null &&
                                    <Typography style={{ marginLeft: '30px' }}>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                        <span style={{ display: 'inline-flex' }}>
                                            <span style={{ minWidth: '230px' }}>{t('resultPreparationTime')}</span><span>{runStatsData.resultPreparationTime}</span>
                                        </span>
                                    </Typography>}
                                    {runStatsData.textIndexingTime != null &&
                                    <Typography style={{ marginLeft: '30px' }}>
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                        <span style={{ display: 'inline-flex' }}>
                                            <span style={{ minWidth: '230px' }}>{t('textIndexingTime')}</span><span>{runStatsData.textIndexingTime}</span>
                                        </span>
                                    </Typography>}
                                </Col>}
                                <Typography className="appTextFont ml-3" ><b>{t('storage')}</b></Typography>
                                <Col lg="12" md="12" className="pr-0 content">
                                    <Typography >
                                        <RadioButtonUncheckedIcon style={{ fontSize: '11px' }} className="mr-2 mt-2 float-left appTextColor" />
                                        <div className={(userInfo && userInfo.current_user.user_class_name === "adminium" && !([...(seqSummary.params?.nucdbs || []), ...(seqSummary.params?.protdbs || [])].some(db => /^CAS.*_MS$/.test(db)) && !userInfo.current_user.cmAccess) ? ' d-block' : 'd-none')}>
                                            <Link className={"appLink"} href="#" onClick={(e) => downloadTechLog(e, workflowId)}>Search Id {workflowId}</Link> consumes {seqSummary && seqSummary.usedSpace} Mb of server disk space​.
                                        </div>
                                        <div className={(userInfo && userInfo.current_user.user_class_name === "adminium" && [...(seqSummary.params?.nucdbs || []), ...(seqSummary.params?.protdbs || [])].some(db => /^CAS.*_MS$/.test(db)) && !userInfo.current_user.cmAccess ? ' d-block' : 'd-none')}>
                                            <Tooltip title="CM access required" placement="top"><span style={{color: '#999', cursor: 'not-allowed'}}>Search Id {workflowId}</span></Tooltip> consumes {seqSummary && seqSummary.usedSpace} Mb of server disk space​.
                                        </div>
                                        <div className={(userInfo && userInfo.current_user.user_class_name !== "adminium" ? ' d-block' : 'd-none')}>
                                            <span className={"appLink" + (userInfo && userInfo.current_user.user_class_name !== "adminium" ? 'd-block' : 'd-none')}>Search Id {workflowId}</span> consumes {seqSummary && seqSummary.usedSpace} Mb of server disk space​.
                                        </div>
                                    </Typography>
                                </Col>
                                <br clear="all" />
                            </Col>
                        }

                    </Row>
                    <br />
                    

                    {(isFailed || isCancelled) &&
                        <span>
                            <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                            <h6 className={"appTextColor loginTitle"} id="logs">Log Details</h6>
                            <Typography className="appTextFont ml-3"><b>Status: </b><span style={{color: 'red'}}>{isFailed ? 'Failed' : 'User cancellation'}</span></Typography>
                            <Typography className="mb-3 ml-3">
                                <a href={process.env.REACT_APP_BASE_URL + "query?do=gqworkflow.get_log&workflow=id:" + workflowId} target="_blank" rel="noreferrer" className="appLink">{t('seeLog')}</a>
                            </Typography>
                        </span>
                    }

                    {gqUserId !== undefined && workflowId !== undefined && !isCmNoAccess && !isCasNoAccess && !isRunning && !isCancelled && !isFailed &&
                        <span><hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                        <SharedWith
                            workflowId={workflowId}
                            gqUserId={gqUserId}
                            sharedWithMe={sharedWithMe.current}
                            getSharedWithMe={getSharedWith}
                        /></span>
                    }
                    {gqUserId !== undefined && workflowId !== undefined && isCmNoAccess && !isRunning && !isCancelled && !isFailed &&
                        <div style={{opacity: 0.5, pointerEvents: 'none'}}>
                        <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>    
                        <SharedWith
                            workflowId={workflowId}
                            gqUserId={gqUserId}
                            sharedWithMe={sharedWithMe.current}
                            getSharedWithMe={getSharedWith}
                        />
                        </div>
                    }
                    {gqUserId !== undefined && workflowId !== undefined && isCasNoAccess && !isCmNoAccess && !isRunning && !isCancelled && !isFailed &&
                        <div style={{opacity: 0.5, pointerEvents: 'none'}}>
                        <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                        <SharedWith
                            workflowId={workflowId}
                            gqUserId={gqUserId}
                            sharedWithMe={sharedWithMe.current}
                            getSharedWithMe={getSharedWith}
                        />
                        </div>
                    }
                    { seqSummary && seqSummary.type !== "GqWfMerge" && seqSummary.type !== "GqWfSeqSearch" && seqSummary.type !== "GqWfAlndbCopy" && !isCmNoAccess && !isCasOnly && !isRunning && !isCancelled && !isFailed &&
                    <span>
                    <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                    <h6 className={"appTextColor loginTitle"} id="alertSettings">{t('alertSetting')}​</h6>
                    {isCasWithOthers &&
                        <Typography className="d-block mb-2" style={{ marginLeft: '1rem' }}>
                            <span style={{color: '#cc6600'}}>⚠ Alerts will run against non-CAS databases only. CAS databases have been excluded.</span>
                        </Typography>
                    }
                    <Row>
                        <Col lg="10" md="10" sm="12" className="p-0 content">
                            <Row>
                                <Col lg="9" md="9" className="pr-0 content" style={{ display: 'flex', alignItems: 'center' }}>
                                    <img className="float-left mx-3" src={alertImg} alt={t('alertSetting')} />
                                    <Typography className={(alarmSetting && alarmSetting.is_created ? 'd-block' : 'd-none')}>
                                        <span>{t('searchRepeatAutomatic')} {alarmSetting && alarmSetting.is_created && Constant['alertOptions'][alarmSetting.relaunch_interval]} {t('emailGoingTo')} {alarmSetting && alarmSetting.email}.{t('alarmSettingText2')}</span>
                                    </Typography>
                                    <Typography className={(alarmSetting && !alarmSetting.is_created ? 'd-block' : 'd-none')}>
                                        <span>{t('alertNotScheduled')}.</span>
                                    </Typography>

                                </Col>
                                <Col lg="12" md="12" sm='12' xs='12' className="pr-0 content float-right">
                                    <Typography className={"float-right " + (alarmSetting && alarmSetting.is_created ? 'd-block' : 'd-none')}>
                                        <Link href="#" title={t('resSharing')} className={"appLink appLink " + (userInfo && userInfo.current_user.gq_user_id === gqUserId ? '' : 'd-none')} onClick={(e) => showAlertModal(e)}>
                                            {t('changeSettings')}
                                        </Link>
                                        <span className={classes.headerPipe + " appTextColor"}>|</span>
                                        <Link href="#" title={t('resSharing')} className={"failedTextColor appLink " + (userInfo && userInfo.current_user.gq_user_id === gqUserId ? '' : 'd-none')} onClick={(e) => removeAlert(e)}>
                                            {t('removeAlert')}
                                        </Link>
                                    </Typography>
                                    <Typography className={"float-right " + (alarmSetting && !alarmSetting.is_created ? 'd-block' : 'd-none')}>
                                        <Link href="#" title={t('resSharing')} className={"appLink appLink " + (userInfo && userInfo.current_user.gq_user_id === gqUserId ? '' : 'd-none')} onClick={(e) => showAlertModal(e)}>
                                            {t('setUpAlert')}
                                        </Link>
                                    </Typography>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    </span>
                    }
                    { isCmNoAccess &&
                    <span>
                    <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                    <h6 className={"appTextColor loginTitle"} id="alertSettings" style={{opacity: 0.5}}>{t('alertSetting')}​</h6>
                    <Row>
                        <Col lg="10" md="10" sm="12" className="p-0 content">
                            <Row>
                                <Col lg="9" md="9" className="pr-0 content" style={{ display: 'flex', alignItems: 'center', opacity: 0.5 }}>
                                    <img className="float-left mx-3" src={alertImg} alt={t('alertSetting')} />
                                    <Typography>
                                        <span style={{color: '#999'}}>CM access required - alerts are deactivated for this search.</span>
                                    </Typography>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    </span>
                    }
                    { isCasOnly && !isCmNoAccess &&
                    <span>
                    <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                    <h6 className={"appTextColor loginTitle"} id="alertSettings" style={{opacity: 0.5}}>{t('alertSetting')}​</h6>
                    <Row>
                        <Col lg="10" md="10" sm="12" className="p-0 content">
                            <Row>
                                <Col lg="9" md="9" className="pr-0 content" style={{ display: 'flex', alignItems: 'center', opacity: 0.5 }}>
                                    <img className="float-left mx-3" src={alertImg} alt={t('alertSetting')} />
                                    <Typography>
                                        <span style={{color: '#999'}}>CAS access required - alerts are deactivated for this search.</span>
                                    </Typography>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    </span>
                    }
                    { seqSummary && seqSummary.type !== "GqWfAlndbCopy" &&
                    <span>
                    <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                     <h6 className={"appTextColor loginTitle"} id="searchHistoryDiv">{t('searchHistory')}</h6>
                    <Row>
                        {/* <Col lg="1" md="1" sm="12" className="pr-0">
                            <img src={searchResultImg} alt="Search History"  />
                        </Col> */}
                        <Col lg="10" md="10" sm="12" className="p-0 content">
                            <Row>
                                <Col lg="10" md="10" sm="10" xs='10' className="pr-0 content">
                                    <img className="float-left mx-3" src={searchResultImg} alt={t('searchHistory')} />
                                    <Typography >
                                        The following previous versions of this search are stored on our servers. Please consider deleting results that you no longer need.​​</Typography>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg="12" md="12">
                            {/* <h6 className={"appTextColor loginTitle"}>{t('alerts')}</h6> */}
                            <DataTable
                                columns={getColumns(alarmSetting, seqSummary, userInfo, gqUserId, downloadTechLog, isCasNoAccess, hasCasAccess)}
                                data={searchHistoryData}
                                defaultSortField="date"
                                defaultSortAsc={false}
                                sortable={false}
                                sortServer={true}
                                // sortIcon={<SortIcon />}
                                onSelectedRowsChange={updateVal}
                                noDataComponent={t('noSearchSubmit')}
                                customStyles= {toggle ? customStyles: customStylesDark}
                                conditionalRowStyles={[
                                    {
                                        when: row => {
                                            const isSharedOrAdmin = gqUserId && userInfo?.current_user?.gq_user_id !== gqUserId || userInfo?.current_user?.user_class_name === "adminium";
                                            return (row.type === "GqWfCmSearch" || (row.databases || []).some(db => /^CAS.*_MS$/.test(db))) && !userInfo?.current_user?.cmAccess && !isSharedOrAdmin;
                                        },
                                        style: toggle ? { color: '#bbb', fontStyle: 'italic' } : { color: '#8c8c90', fontStyle: 'italic' },
                                    },
                                    {
                                        when: row => {
                                            if (row.casDatabases !== undefined && row.casDatabases.length > 0) {
                                                const casDbsInSearch = (row.databases || []).filter(db => row.casDatabases.includes(db));
                                                return !hasCasAccess && casDbsInSearch.length > 0;
                                            }
                                            return isCasNoAccess;
                                        },
                                        style: toggle ? { color: '#bbb', fontStyle: 'italic' } : { color: '#8c8c90', fontStyle: 'italic' },
                                    },
                                ]}
                                //selectableRowsNoSelectAll
                                // selectableRowsComponent={(props) => (
                                //     <Checkbox
                                //       style={toggle?{color: ''} :{color: '#aea9a9'}}
                                //     />
                                // )} 
                                selectableRowsComponent={Checkbox}
                                selectableRowsComponentProps={selectableRowsComponentProps}
                                selectableRowSelected={selectAll ? rowSelectionCriteria : defaultRowSelectionCriteria}
                                clearSelectedRows={toggleCleared}
                                selectableRowDisabled={row => false}
                                selectableRows
                                noHeader={true}
                                subHeader={true}
                            // onRowClicked={getRowData}
                            // onRowClicked={getRowData}
                            // clearSelectedRows={clearCheckedRow}
                            />
                        </Col>
                        {/* <Col lg="12" md="12" className="pr-0 content float-right mt-3 ml-3">
                            <h6 className={"appTextColor loginTitle"}>{t('redos')}</h6>
                            <DataTable
                                columns={columns}
                                data={redoData}
                                defaultSortField="date"
                                defaultSortAsc={false}
                                sortable={false}
                                sortServer={true}
                                // sortIcon={<SortIcon />}
                                onSelectedRowsChange={updateVal}
                                noDataComponent={t('noSearchSubmit')}
                                customStyles={customStyles}
                                selectableRowsNoSelectAll
                                selectableRowsComponent={Checkbox}
                                selectableRowsComponentProps={selectableRowsComponentProps}
                                selectableRows
                                noHeader={true}
                                subHeader={true}
                            // onRowClicked={getRowData}
                            // onRowClicked={getRowData}
                            // clearSelectedRows={clearCheckedRow}
                            />
                        </Col> */}
                        <Col lg="12" md="12" className={"mt-3 px-5" + (searchHistoryData.length > 0 && (userInfo && userInfo.current_user.gq_user_id === gqUserId) ? ' d-block' : ' d-none')} >
                            {
                                disableDelete ?
                                    <Button className={classes.cancelButtonModal} disableRipple={true}   >{t('deleteSelected')}</Button>
                                    :
                                    <Button className='float-left accountInfo m-1' disableRipple={true} type="submit" onClick={(e) => deleteSearch('single')}>{t('deleteSelected')}</Button>



                            }

                            <Button onClick={() => ToggleAllRowsSelected()} disableRipple={true} className="float-left  accountInfo" type="submit">{!selectAll ? t('selectAllResults') : t('deselectAllResults')}</Button>

                            {/* <Button  disabled={disableDelete}  className={ 'float-left' + (disableDelete ? classes.cancelButtonModal : 'accountInfo')} type="submit" onClick={(e)=>deleteSearch('single')}>{t('deleteSelected')}</Button> */}


                        </Col>
                    </Row>
                    </span>
                    }
                    <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                    <div>
                    <h6 className={"appTextColor loginTitle"} id="notesDiv">{t('notes')}</h6>

                    <div lg="10" md="10" sm="10" xs='10' className="pr-0 content">
                        <img className="float-left" style={{marginRight: '1rem'}} src={notesImg} alt={t('notes')} />
                        <div className={'appTextFont appTextColor'} style={{width: "75%", marginBottom: "20px"}}>
                            You can leave notes in the box below. Press "Save Notes" to remember them. Notes are visible to and editable by people you share this result with.
                        </div>
                    </div>

                    <div className="form-group">
                        <TextInput
                            rowsMax="8"
                            rows="8"
                            multiline={true}
                            fullWidth
                            id="notes"
                            name="notes"
                            label={t('notesComment')}
                            variant="outlined"
                            value={notes || ''}
                            onChange={(e) => setNotes(e.target.value)}
                        />
                    </div>
                    <div>
                        <Button className="mr-2 accountInfo" type="submit" onClick={updateNotes}>{t('saveNotes')}</Button>
                    </div>
                    </div> 
                    </Col>
                </Row>
            <Modal
                show={alertSettingModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcente"
                centered
                contentClassName={toggle ? classes.modalClassContentDSI: classes.modalClassContentDSIDark}
                className={classes.modalBoxContent}
            >
                {/* <Modal.Header className={classes.modalHeaderDSI}>
                    <Link href="#" onClick={(e) => e.preventDefault()} className={"float-right  appTextColor"}>
                        <CloseIcon onClick={() => setAlertSettingModal(!alertSettingModal)} />
                    </Link>
                </Modal.Header> */}
                <Link href="#" onClick={(e) => e.preventDefault()} className={classes.closeButton + " appTextColor"}>
                    <CloseIcon onClick={() => setAlertSettingModal(!alertSettingModal)} />
                </Link>
                <div className={"text-center appTextColor " + classes.bodyPadding}>
                    <div className={(toggle ? classes.colorContainerDSI : classes.colorContainerDSIDark) + " pl-5"}>
                        <div className={classes.alertRow}>
                            <label className={"mb-3 mt-2 float-left " + classes.alertRowLabel}>{t('alertFrequency')}</label>
                            <SelectBox
                                margin="normal"
                                variant="outlined"
                                name="changeAlert"
                                id="changeAlert"
                                value={alertSettingValue}
                                items={alertSettingData}
                                onChange={(e) => setAlertSettingValue(e.target.value)}
                                className={"float-left ml-3" + ' ' + (classes.alertSelect)}
                            />
                        </div>
                        <div className={classes.alertRow}>
                            <label className={"mb-3 mt-2 float-left " + classes.alertRowLabel}>{t('exportTemplate')}</label>
                            <SelectBox
                                margin="normal"
                                variant="outlined"
                                name="changeAlertView"
                                id="changeAlertView"
                                value={alertViewValue}
                                items={alertViewData}
                                menuMaxHeight={300}
                                onChange={(e) => {alertViewValueRef.current = e.target.value; setAlertViewValue(e.target.value);}}
                                className={"float-left ml-3" + ' ' + (classes.alertSelect)}
                            />
                        </div>
                        <br></br>
                        <br></br>
                        <div className={classes.footerDiv + " float-right"}>
                            <Button onClick={updateAlertSettings} className="accountInfo" >{t('updateAlert')}</Button>
                            <Button onClick={() => setAlertSettingModal(!alertSettingModal)} className={classes.loginSubmitCancel} >{t('cancel')}</Button>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                show={modalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcente"
                centered
                contentClassName={toggle? classes.modalClassContent: classes.modalClassContentDark}
                className={classes.modalBoxContent}
            >
                {/* <Modal.Header className={classes.modalHeader}>
                    <Link href="#" onClick={(e) => e.preventDefault()} className={"float-right  appTextColor"}>
                        <CloseIcon onClick={closeModal} />
                    </Link>
                </Modal.Header> */}
                <Link href="#" onClick={(e) => e.preventDefault()} className={classes.closeButton + " appTextColor"}>
                    <CloseIcon onClick={closeModal} />
                </Link>
                <div className={"text-center appTextColor " + classes.bodyPadding}>
                    <div className={toggle ? classes.colorContainer: classes.colorContainerDark}>
                        <div className={(confirmContent ? 'd-block' : 'd-none')}>
                            <p className="mb-3"><b>{t('deleteSelItems')}</b></p>
                            <p className="mb-3">{t('deleteSelItemContent')}</p>
                            <div className="mb-5 h-100">
                                <Checkbox
                                    color="primary"
                                    className={"float-left p-0 " + classes.checkBox}
                                    name="acceptTerms"
                                    id="acceptTerms"
                                    checked={termsDisable}
                                    onClick={() => setTermsDisable(!termsDisable)}
                                />
                                <p className={"float-left ml-1"}>{t('termsConditionText')}</p>
                            </div>
                            <div className={classes.footerDiv + " float-right"}>
                                <Button onClick={() => deleteConfirm()} disabled={!termsDisable} className={"mr-2 " + ' ' + (!termsDisable ? 'cancelButtonDisable' : 'accountInfo')} >{t('deleteSelItems')}</Button>
                                <Button onClick={closeModal} className={classes.loginSubmitCancel}>{t('cancel')}</Button>
                            </div>
                        </div>
                        <div className={"text-center " + (delLoaderContent ? 'd-block' : 'd-none')}>
                            <p className="mb-3">{t('deletingItems')}</p>
                            <p className="mb-3">{t('takeTimeText')}</p>
                        </div>
                        <div className={(errorContent ? 'd-block' : 'd-none')}>
                            <p className="mb-3">{t('errorDeletTitle')}</p>
                            <p className="mb-3">{t('contactText1')} <a href="GQ-Support@aptean.com" onClick={(e) => e.preventDefault()}>GQ-Support@aptean.com</a> {t('contactText2')}</p>
                            <div className={classes.footerDiv + " float-right"}>
                                <Button onClick={closeModal} className="mr-2 accountInfo" >{t('close')}</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Alert Report Modal */}
            <Modal
                show={alertReportModal}
                onHide={() => setAlertReportModal(false)}
                size="xl"
                fullscreen
                aria-labelledby="alert-report-modal"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Alert Report</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: '0', height: '85vh', overflow: 'auto' }}>
                    {alertReportData && (
                        <div
                            dangerouslySetInnerHTML={{ __html: alertReportData }}
                            style={{ padding: '20px' }}
                        />
                    )}
                </Modal.Body>
            </Modal>
        </div>
    )
}


export default SearchResultSequence;
